export default {
  "common": {
    "view_more": "表示を増やす",
    "hide": "表示しない",
    "view_less": "表示を減らす",
    "edit": "編集",
    "remove": "外す",
    "delete": "削除",
    "welcome_message": "組織向けELSAへようこそ",
    "slogan": "流暢に、容易に、自身を持って英語を話す",
    "invited_by": "招待者",
    "agree_to": "同意する",
    "terms_and_conditions": "ELSA利用規約",
    "search": "検索",
    "email": "ｅメール",
    "cancel": "キャンセル",
    "save": "保存",
    "finish": "終了",
    "done": "完了",
    "assign": "振り分ける",
    "or": "または",
    "ok": "OK",
    "none": "該当なし",
    "account_confirmed": "アカウントが確認されました。",
    "no_values": "値なし",
    "terms_and_privacy_policy": "利用規約とプライバシーポリシー",
    "continue": "続ける",
    "invite": "招待する",
    "generic_error_message": "問題が発生しました。再度試してください。",
    "error_duplidate_group_name": "ファイル内のクラス名が重複しています。",
    "login": "ログイン",
    "and": "＆",
    "terms_of_use": "利用規約",
    "privacy_policy": "プライバシーポリシー",
    "name": "名前",
    "new": "新規",
    "view_list": "リストを表示",
    "total": "合計",
    "lesson": "レッスン",
    "lessons": "レッスン",
    "hours": "時間",
    "hour": "時間",
    "days": "日",
    "day": "日",
    "average": "平均",
    "lessons_per_day": "1日のレッスン数",
    "minutes_per_day": "1日あたりの時間（分）",
    "pending_invites": "保留中の招待",
    "invite_success": "招待状が正常に受信されました。",
    "invite_not_success": "招待状が受信できませんでした。",
    "invite_send_not_success": "招待状を再送信できませんでした。",
    "no_invite_seleted": "招待状が選択されていません。",
    "select_all": "全選択",
    "deselect_all": "全削除",
    "minutes": "分",
    "warnings": {
      "no_report_data": "レポートが獲得できませんでした。再度お試しください。",
      "session_expired": "一定時間操作がなかったため、サインアウトされました。続行するには、サインインしてください。",
      "could_not_load_resource": "リソースの読み込みに失敗しました"
    },
    "resend_invite": "招待状の再送",
    "remove_invite": "保留中の招待状を削除する",
    "export_report": "レポートをエクスポート",
    "export_assessment": "評価をエクスポート",
    "lesson_detail": "レッスン詳細",
    "file_type_not_allowed": "ファイルの種類が許可されていません",
    "import": "インポート",
    "assessment-history": "評価履歴",
    "remove_user_from_system_success": "システムからユーザーを正常に削除しました",
    "remove_user_from_system_warning": "システムからユーザーを削除できませんでした",
    "add_role_to_user_success": "役割の振り分けに成功しました。",
    "add_role_to_user_warning": "役割の振り分けができませんでした。",
    "remove_user_from_system": "選択されたユーザーは、システムから削除されます。",
    "no_assessment_test_in_periods": "期間中のアセスメントテストはありません。",
    "no_lessons_in_periods": "期間中のレッスンはありません。",
    "items": "アイテム",
    "item": "アイテム",
    "data_selelected_info": "{selected} 中{total}が選択されています。",
    "from_date_to_up_date": "{from_date}から{to_date}まで",
    "adding_duplicate_warning": "このアイテムは既にお持ちです。",
    "tag_input_max_length_warning": "この項目は{max_length}文字より長く入力することはできません。編集してください。",
    "rename": "名前の変更",
    "add": "追加",
    "loading": "読み込み中",
    "choose_a_topic": "トピックを選択する",
    "filter": "フィルター",
    "start_end_of_total": "{2} 中 {0} - {1} ",
    "invite_teachers_title": "招待 {0}",
    "tag_input": {
      "click_here_to_view": "スペルの誤りを表示するには、ここをクリック。",
      "there_are_spelling_grammar": "スペルや文法の間違いがあります。クリック",
      "text_icon_for_suggestions": "アイコンをクリックすると候補が表示されます。"
    },
    "class_time_export_title": "{0} 件のレポート",
    "exporter_title": {
      "student_name": "生徒名",
      "student_email": "生徒のメールアドレス",
      "lessons_practiced": "学習したレッスン",
      "studied_time": "学習時間",
      "average_daily_minutes_practiced": "1日の平均学習時間（分）",
      "average_daily_lessons_practiced": "1日の平均学習レッスン数",
      "duration_days": "期間（日）",
      "first_eps": "第１EPS",
      "last_eps": "最終EPS",
      "last_date_practiced": "最終学習日",
      "last_assessment_score": "最終評価点",
      "last_assessment_date": "最終評価日",
      "score_improvement": "評価点の改善",
      "eps_improvement": "EPSの改善"
    },
    "copy_of": "コピー",
    "json_excel_download": "ダウンロード{0}件",
    "elsa_dashboard": "ELSAダッシュボード",
    "action": "アクション"
  },
  "date_interval_picker": {
    "start_end_date": "開始＆終了日",
    "save": "保存",
    "cancel": "キャンセル",
    "this_month": "今月",
    "apply": "応募"
  },
  "date_picker": {
    "start_date": "開始日",
    "end_date": "終了日",
    "to": "To",
    "last_week": "先週",
    "last_month": "先月",
    "last_three_months": "過去３ヶ月",
    "last_six_months": "過去６ヶ月",
    "last_year": "去年",
    "daily": "日間",
    "weekly": "週間",
    "monthly": "ヶ月間"
  },
  "company_labels": {
    "average_lessons": "週当たりの学習日数",
    "all_users": "全学習者",
    "groups": "チーム",
    "group": "チーム",
    "teachers": "チームリーダー",
    "remove_teacher_from_organization": "リーダーを組織から削除",
    "remove_student_from_organization": "学習者を組織から削除",
    "update_teacher_from_organization": "組織のリーダーを更新",
    "update_student_from_organization": "組織の学習者を更新",
    "remove_student_from_group": "学習者をチームから削除",
    "active_students": "学習中の生徒",
    "teacher": "チームリーダー",
    "students": "学習者",
    "student": "学習者",
    "all_groups": "全チーム",
    "edit_group": "チームを編集",
    "select_group": "チームを選択",
    "add_to_group_title": "チームに追加",
    "remove_from_group_tilte": "チームから外す",
    "remove_teacher": "リーダーをチームから外す",
    "assign_teacher": "リーダーをチームに割り当てる",
    "add_to_group": "新しいチームを追加",
    "add_studyset_to_group": "新しい学習セットを追加",
    "import_class_success_title": "{numberClassesImported} のチームが正常に作成されました。",
    "add_to_group_success": "ユーザーがチームに追加されました。",
    "remove_from_group_success": "ユーザーがチームから削除されました。",
    "remove_from_class_success": "ユーザーがチームから削除されました。",
    "remove_from_class_warning": "ユーザーをチームから削除できませんでした。",
    "assign_license_to_user_success": "ユーザーへのライセンス割り当てが完了しました。",
    "assign_license_to_user_warning": "ユーザーへのライセンス割り当てができませんでした。",
    "remove_from_organization_success": "ユーザーが組織から削除されています。",
    "remove_from_organization_warning": "ユーザーが組織から削除されませんでした。",
    "update_learner_of_organization_success": "ユーザー情報が正常に更新されました。",
    "update_learner_of_organization_warning": "ユーザー情報が更新できませんでした。",
    "update_teacher_of_organization_success": "ユーザー情報が正常に更新されました。",
    "update_teacher_of_organization_warning": "ユーザー情報が更新できませんでした。",
    "add_to_group_warning": "ユーザーがチームに追加できませんでした。",
    "remove_from_group_warning": "ユーザーがチームから削除できませんでした。",
    "remove_teacher_from_group_success": "教師がチームから削除されています。",
    "remove_teacher_from_group_warning": "教師がチームから削除できませんでした。",
    "assign_teacher_to_group_success": "リーダーがチームに割り当てられています。",
    "assign_teacher_to_group_warning": "リーダーをチームに割り当てられませんでした。",
    "class_has_not_teacher": "チームにリーダーが割り当てられていません。",
    "class_has_teacher": "チームにリーダーが割り当てられています。",
    "delete_group_success": "チームを削除しました。",
    "delete_group_warning": "チームを削除できませんでした。",
    "confirm_remove_user_from_group": "このユーザーをチームから削除しますか？",
    "confirm_remove_teacher_from_group": "この教師をチームから削除しますか？",
    "create_new_group": "新しいチームを作成",
    "no_groups_yet": "まだチームがありません",
    "no_students_yet": "まだ学習者がいません",
    "create_group": "チームを作成",
    "import_groups": "チームをインポート",
    "import_groups_success": "チームの作成が完了しました。",
    "import_users_to_groups_success": "学習者のチームへのインポートに成功",
    "group_title": "チームタイトル",
    "group_name": "チーム名",
    "group_details": "チーム詳細",
    "step_group_details": "チーム詳細",
    "no_teachers_available": "リーダーがいません",
    "no_group_available": "チームがありません",
    "all_teachers": "全リーダー",
    "all_students": "全学習者",
    "upload_emails": "学習者をチームにインポート",
    "errors": {
      "please_provide_group_name": "チーム名を入力してください",
      "please_provide_teacher_name": "リーダー名を入力してください",
      "please_select_team": "チームを選択してください"
    },
    "add_students": "学習者を追加",
    "edit_student": "学習者を編集",
    "edit_teacher": "リーダーを編集",
    "group_overview": "チーム概要",
    "group_teacher": "チームリーダー",
    "will_be_added_students": "クラスを作成次第{numberOfUsers}名の生徒が追加されます。",
    "student_consent_to_class": "{numberOfUsers}名の生徒が自動的にチームに登録されます。",
    "students_list": "生徒リスト",
    "your_group_was_created": "あなたのチームが作成されました。",
    "your_group_was_created_draft": "あなたのチームがドラフトに作成されました。",
    "error_when_inviting": "生徒を招待する際にエラーが発生しました。後でもう一度お試しください。",
    "invited_users": "{students}生徒が招待されました。",
    "goals": {
      "engage_students": "チームの学習目標を設定",
      "engage_review": "生徒に英語の練習を始めるように通知しましょう。",
      "get_insight_about_students": "生徒の発音スキルの現状把握"
    },
    "invite_students": "生徒を招待",
    "student_name": "生徒名",
    "teachers_page": {
      "title": "チームリーダー",
      "invite": "リーダーを招待",
      "table": {
        "number_of_students": "生徒数",
        "number_of_classes": "チーム数"
      }
    },
    "students_page": {
      "title": "生徒",
      "invite": "生徒を招待"
    },
    "curriculum_page": {
      "title": "カリキュラム"
    },
    "select_teacher": "チームリーダーを選択",
    "add_new_teacher": "チームリーダーを追加",
    "invite_new_teacher": "新規チームリーダーを招待",
    "invite_single_teacher": "チームリーダーを個別に追加",
    "invite_multiple_teachers": "ｅメールで複数のチームリーダーを追加",
    "dashboard": {
      "class_overview": "チーム概要",
      "view_class": "チームを表示",
      "profile": "学校概要",
      "add_student": "生徒を招待",
      "new_group": "新規チームを作成",
      "add_teacher": "リーダーを招待"
    },
    "teacher_info": {
      "show_list_of_classes": "チームのリストを表示",
      "show_list_of_students": "生徒のリストを表示",
      "classes_assigned_to": "担当チーム",
      "show_all_classes": "全チームを表示"
    },
    "classes": {
      "active_students": "練習中の生徒（少なくとも1つのレッスンを学習中）",
      "import_users": "生徒を複数チームにインポート"
    },
    "students_improvement": "チーム改善",
    "empty_users_message_confirm": "生徒を追加していませんが、続行しますか？",
    "auto_enroll_message_confirm": "生徒は自動的にチームに登録されます。<br/>自動登録オプションを選択すると、生徒をこのチームに登録するには生徒による事前の了承が必要となります。<br/>続けますか？",
    "accept_invitation_enroll_message_confirm": "生徒がチームに参加するには、個別に招待を受ける必要があります。続けますか？",
    "teacher_auto_enroll_message_confirm": "チームリーダーは自動的にチームに登録されます。<br/>自動登録オプションを選択すると,チームリーダーをこのチームに登録するにはリーダーによる事前の了承が必要となります。<br/>続けますか？",
    "teacher_accept_invitation_enroll_message_confirm": "チームリーダーをチームに登録するために,個別に招待する必要があります。続けますか？",
    "pending_invites_teacher": "保留中のリーダーを招待",
    "modals": {
      "delete": {
        "title": "組織からチームを削除",
        "message": "本当に{numberOfClasses}件のチームを組織から削除しますか？"
      },
      "invite_users": {
        "select_group_placeholder": "チームを選択",
        "assign_group": "チームを割り当て（任意）",
        "no_group_available": "チームがありません",
        "no_class_needed": "招待のみで、チームは必要ありません。"
      },
      "delete_from_group": {
        "title": "チームからユーザーを削除",
        "message": "本当に{numberOfAccounts}名のユーザーをチームから削除しますか？",
        "confirm": "削除",
        "cancel": "キャンセル"
      }
    },
    "create_group_flow": {
      "group_details": {
        "group_name_input_placeholder": "チーム名を入力",
        "team_detail_tooltip": "各チームに名前が必要です",
        "start_end_date": "開始日と終了日"
      },
      "add_students": {
        "add_students_tooltip": "メールアドレスを入力するか、メールアドレスのリストをインポートして、生徒をクラスに招待します。",
        "add_students_input_placeholder": "各メールアドレスを入力したら、[Enter] をクリックします。"
      },
      "group_created": {
        "goals_section": {
          "assessment_test_desc": "チームが評価を完了する必要がある日付を設定してください。"
        }
      }
    },
    "no_groups_desc": "最初のチームを作成し、学習者をチームに招待しましょう。",
    "groups_desc": "チーム・チームリーダーおよび学習者のELSAへのアクセスを管理します。",
    "get_set_up": {
      "title": "設定する",
      "title_note": "まずはこのオンボーディングチェックリストを使いましょう。",
      "step1": {
        "title": "共同管理者の追加",
        "description": "アカウントに1人または複数のアソシエイト管理者を追加します。管理者は、チームの作成・目標やリマインダーの設定、生徒の招待、レポートの確認を行うことができます。管理者は、必要に応じていつでも追加・削除することができます。",
        "button": "管理者の追加"
      },
      "step2": {
        "title": "チームリーダーの招待",
        "description": "チームを管理するチームリーダーを招待します。",
        "button": "チームリーダーの招待"
      },
      "step3": {
        "title": "チームの作成",
        "description": "チームの作成,チームリーダーの割り当て,チーム目標の設定を行います。",
        "button": "チームの作成"
      },
      "step4": {
        "title": "学習者の招待",
        "description": "学習者をチームに招待するには、提案されたフォームを使って学習者のメールアドレスを手動で追加またはアップロードします。招待された学習者は、ELSAへの登録が可能になります。",
        "button": "学習者の招待"
      }
    },
    "charts": {
      "organization_performance": "組織のパフォーマンス",
      "distribution_by_learners_title": "学習者の分布",
      "distribution_by_learners_desc": "ELSAのスコア範囲に基づいて計算されています。",
      "teamview_leaderboard_org_label": "チームビュー",
      "team_study_goal": "チームの学習目標",
      "group": {
        "average_elsa_score_historical_progress_title": "ELSAスコアの平均進捗状況",
        "average_elsa_score_historical_progress_desc": "チームの平均ELSAスコアの経時変化",
        "average_elsa_score_desc": "あなたのチームの生徒の結果に基づいて",
        "average_elsa_score_title": "チームの平均レベル",
        "learning_effort_decs": "練習時間とレッスン数の比較",
        "learning_effort_title": "チームの学習努力",
        "pentagon_title": "ELSAスコアのスキル別内訳",
        "pentagon_desc": "チーム内の学習者の結果に基づく",
        "ielts_title": "IELTSスピーキングスコア分布",
        "ielts_desc": "EPSスコアに基づいて予測されます。これは IELTS または IDP によって、承認または推奨されたものではありません。",
        "no_ielts_data_title": "生徒からのデータがまだ十分ではありません。",
        "no_ielts_data_desc": "スピーキングのスコア予測をするためには、アセスメントテストを受けるか、より多くのレッスンを練習するように生徒に通知してください。",
        "performance_title": "チームのパフォーマンス",
        "highest_average_score_skills_title": "チームの実績"
      },
      "organization": {
        "average_elsa_score_historical_progress_title": "組織の平均ELSAスコアの経時変化",
        "average_elsa_score_historical_progress_desc": "組織の平均Elsaスコアの経時変化",
        "average_elsa_score_desc": "組織の学習者の結果に基づく",
        "average_elsa_score_title": "組織の平均レベル",
        "learning_effort_decs": "練習時間数と練習レッスン数の比較",
        "learning_effort_title": "組織の学習への努力",
        "pentagon_title": "ELSAスコアのスキル別内訳",
        "pentagon_desc": "組織内の学習者の結果に基づく",
        "ielts_title": "IELTSスピーキングスコア分布",
        "ielts_desc": "EPSスコアに基づいて予測しています。これは IELTS または IDP によって、承認または推奨されたものではありません。",
        "no_ielts_data_title": "学習者からのデータがまだ十分ではありません。",
        "no_ielts_data_desc": "スピーキングのスコア予測をするためには、アセスメントテストを受けるか、より多くのレッスンを練習するように学習者に通知してください。",
        "performance_title": "組織のパフォーマンス",
        "highest_average_score_skills_title": "組織の実績"
      },
      "learner_col_label": "チーム名",
      "tooltips": {
        "group_eps": "選択された期間におけるチームの学習者から算出された最新の平均スコア",
        "group_durations": "選択された期間中のチームの総練習時間（HH:MM:SS形式）",
        "group_lessons_total": "チームが練習した総レッスン数"
      }
    },
    "study_sets": {
      "organization": "組織",
      "group": "チームのみ",
      "public": "公開",
      "assign_to_group": "チームに割り当て",
      "assign_to_groups": "チームに割り当て済み",
      "assign_to_another_group": "別のチームに割り当て",
      "recent_assigned_group": "最近に割り当てられたチーム",
      "assigned_groups": "割り当てられたチーム",
      "no_study_sets_desc": "学習セットは、自分のチームに割り当てることができるようにカスタマイズされたレッスンです。",
      "modals_delete_title": "選択した学習セットを削除すると、現在のチームにも影響します。続けますか？",
      "information_assignments_assigned_to": "お探しのチームが見つかりませんか？そのチームの名前を入力して,Enterキーを押してください。",
      "information_study_set_shareable_to": "チームのみ：学習セットは、学習セットを割り当てたチームの学習者のみが閲覧できます。\n私の組織：学習セットは、組織のメンバー（管理者や他のリーダーなど）が閲覧できます。\n公開：学習セットは、すべてのELSAユーザーが閲覧できます。"
    },
    "assignments": {
      "modals_delete_title": "選択した課題を削除してよろしいですか？",
      "modals_delete_decs": "課題は学習者の端末から進捗状況とともに削除されます。",
      "modals_delete_detail_title": "この課題を削除してよろしいですか？",
      "modals_delete_detail_decs": "課題は学習者の端末から進捗状況とともに削除されます。",
      "no_assignments_yet": "あなたのチームにはまだ課題がありません。"
    },
    "homework_library": {
      "assigned_group": "割り当てられたチーム"
    },
    "invite_teacher": {
      "firstname": "名前（名）",
      "last_name": "名前（姓）",
      "email_validation_msg": "正しいメールアドレスを入力してください。"
    },
    "groups_col_label": ""
  },
  "school_labels": {
    "average_lessons": "1週間の練習日数",
    "all_users": "すべての学習者",
    "groups": "クラス",
    "group": "クラス",
    "teachers": "先生",
    "teacher": "先生",
    "students": "学習者",
    "student": "学習者",
    "active_students": "アクティブな学習者",
    "remove_teacher_from_organization": "リーダーを組織から削除",
    "remove_student_from_organization": "学習者を組織から削除",
    "update_teacher_from_organization": "組織のリーダーの更新",
    "update_student_from_organization": "組織の学習者の更新",
    "remove_student_from_group": "クラスから学習者を削除",
    "all_teachers": "すべての先生",
    "all_students": "すべての学習者",
    "all_groups": "すべてのクラス",
    "select_group": "クラスの選択",
    "edit_group": "クラスの編集",
    "add_to_group_title": "クラスに追加",
    "remove_from_group_tilte": "クラスから削除",
    "remove_teacher": "先生をクラスから削除",
    "assign_teacher": "先生をクラスに割り当てる",
    "add_to_group": "新しいクラスの追加",
    "add_studyset_to_group": "新しい学習セットの追加",
    "import_class_success_title": "{numberClassesImported}件のクラスの作成が完了しました。",
    "add_to_group_success": "ユーザーがクラスに追加されました。",
    "remove_from_group_success": "ユーザーがクラスから削除されました。",
    "remove_from_organization_success": "ユーザーが組織から削除されました。",
    "remove_from_organization_warning": "ユーザーを組織から削除できませんでした。",
    "update_learner_of_organization_success": "ユーザーは正常に更新されました。",
    "update_learner_of_organization_warning": "ユーザーは正常に更新されませんでした。",
    "update_teacher_of_organization_success": "ユーザーは正常に更新されました。",
    "update_teacher_of_organization_warning": "ユーザーは正常に更新されませんでした。",
    "remove_from_class_success": "ユーザーがチームから削除されました。",
    "remove_from_class_warning": "ユーザーをチームから削除できませんでした。",
    "assign_license_to_user_success": "ユーザーへのライセンスの割り当てが正常に完了しました。",
    "assign_license_to_user_warning": "ユーザーにライセンスを割り当てが正常に完了しませんでした。",
    "add_to_group_warning": "ユーザーをクラスに追加できませんでした。",
    "remove_from_group_warning": "ユーザーをクラスから削除できませんでした。",
    "remove_teacher_from_group_success": "クラスから先生を削除しました。",
    "remove_teacher_from_group_warning": "クラスから先生を削除できませんでした。",
    "assign_teacher_to_group_success": "クラスに先生を割り当てました。",
    "assign_teacher_to_group_warning": "クラスに先生を割り当てられませんでした。",
    "class_has_not_teacher": "クラスに先生が割り当てられていません。",
    "class_has_teacher": "クラスに先生が割り当てられています。",
    "delete_group_success": "クラスの削除に成功しました",
    "delete_group_warning": "クラスの削除に失敗しました",
    "confirm_remove_user_from_group": "このユーザーをクラスから削除してよろしいですか？",
    "confirm_remove_teacher_from_group": "この教師をクラスから削除してよろしいですか?",
    "create_new_group": "新しいクラスの作成",
    "no_groups_yet": "組織にはまだクラスがありません。",
    "no_students_yet": "あなたにはまだ学習者がいません。",
    "no_teachers_available": "先生がいません",
    "no_group_available": "チームがありません",
    "create_group": "クラスの作成",
    "import_groups": "クラスのインポート",
    "import_groups_success": "クラスが作成されました",
    "import_users_to_groups_success": "クラスに学習者を正常にインポートしました",
    "group_title": "クラスのタイトル",
    "group_name": "クラス名",
    "group_details": "クラスの詳細",
    "step_group_details": "クラスの詳細",
    "select_teacher": "先生の選択",
    "add_new_teacher": "新しい先生の追加",
    "invite_new_teacher": "新しい先生の招待",
    "invite_single_teacher": "個別の先生を追加",
    "invite_multiple_teachers": "メールで複数の先生を追加",
    "upload_emails": "クラスに学習者をインポートする",
    "errors": {
      "please_provide_group_name": "クラス名を入力してください",
      "please_provide_teacher_name": "先生の名前を入力してください",
      "please_select_class": "クラスを選択してください"
    },
    "add_students": "学習者の追加",
    "edit_student": "学習者の編集",
    "edit_teacher": "先生の編集",
    "group_overview": "クラスの概要",
    "group_teacher": "クラスの教師",
    "will_be_added_students": "{numberOfUsers}人の学習者が、クラスを作成すると同時に追加されます。",
    "student_consent_to_class": "{numberOfUsers}人の学習者がクラスに自動登録されます。",
    "students_list": "学習者リスト",
    "your_group_was_created": "クラスが作成されました。",
    "your_group_was_created_draft": "クラスが下書き保存されました。",
    "error_when_inviting": "学習者を招待する際にエラーが発生しました。後でもう一度お試しください。",
    "invited_users": "{students}人の学習者が招待されました。",
    "goals": {
      "engage_students": "クラスの学習目標を設定する",
      "engage_review": "学習者に英語の練習を始めてもらうことができます。その手始めにお勧めの方法をご紹介します:",
      "get_insight_about_students": "学習者の現在の発音スキルを把握する"
    },
    "invite_students": "学習者を招待する",
    "student_name": "学習者の名前",
    "teachers_page": {
      "title": "先生",
      "invite": "先生を招待する",
      "table": {
        "number_of_students": "学習者数",
        "number_of_classes": "クラス数"
      }
    },
    "students_page": {
      "title": "学習者",
      "invite": "学習者を招待する"
    },
    "curriculum_page": {
      "title": "カリキュラム",
      "create_new_studyset": "新しい学習セットの作成",
      "no_studysets_yet": "現在、学習セットはありません。",
      "no_studysets_desc": "学習セットとは、自分のクラスに割り当てることのできるカスタマイズされたレッスンです。"
    },
    "dashboard": {
      "class_overview": "クラスの概要",
      "view_class": "クラスを表示",
      "profile": "学校のプロフィール",
      "add_student": "学習者を招待する",
      "new_group": "新しいクラスの作成",
      "add_teacher": "先生を招待する"
    },
    "teacher_info": {
      "show_list_of_classes": "クラスリストを表示",
      "show_list_of_students": "学習者リストを表示",
      "classes_assigned_to": "次に割り当てられたクラス:",
      "show_all_classes": "すべてのクラスを表示"
    },
    "classes": {
      "active_students": "アクティブな学習者（1レッスン以上練習した人）",
      "import_users": "複数のクラスに学習者をインポート"
    },
    "students_improvement": "クラスの改善",
    "empty_users_message_confirm": "学習者を追加していませんが、続行しますか？",
    "auto_enroll_message_confirm": "学習者は自動的にクラスに登録されます。<br/>自動登録を選択する場合、学習者をこのクラスに追加するには、学習者の事前の許可が必要です。<br/><br/>続行しますか？",
    "accept_invitation_enroll_message_confirm": "学習者がクラスに参加するには、個別に招待を受け取らなければなりません。<br/>続行しますか？",
    "teacher_auto_enroll_message_confirm": "先生は自動的にクラスに登録されます。<br/>自動登録オプションを選択する場合、先生をこのクラスに追加するために、先生から事前許可を得なければなりません。<br/><br/>続行しますか？",
    "teacher_accept_invitation_enroll_message_confirm": "先生がクラスに参加するには、個別に招待を受け取らなければなりません。<br/>続行しますか？",
    "pending_invites_teacher": "保留中の招待（先生）",
    "delete_user_from_class_message_confirm": "学習者を削除してよろしいですか？",
    "modals": {
      "delete": {
        "title": "組織からクラスを削除",
        "message": "{numberOfClasses}件のクラスを組織から削除してよろしいですか？"
      },
      "invite_users": {
        "select_group_placeholder": "クラスの選択",
        "assign_group": "クラスを割り当てる（任意）",
        "no_group_available": "クラスがありません",
        "no_class_needed": "招待のみ、クラスは未振分"
      },
      "delete_from_group": {
        "title": "クラスから学習者を削除",
        "message": "クラスから{numberOfAccounts}人の学習者を削除してよろしいですか？",
        "confirm": "削除",
        "cancel": "キャンセル"
      }
    },
    "create_group_flow": {
      "group_details": {
        "group_name_input_placeholder": "クラス名を入力してください。",
        "team_detail_tooltip": "各クラスには名前が必要です。",
        "start_end_date": "開始日と終了日"
      },
      "add_students": {
        "add_students_tooltip": "学習者のメールアドレスを入力するか、メールアドレスのリストをインポートして、クラスに学習者を追加します。",
        "add_students_input_placeholder": "それぞれのメールアドレスを入力したら,[Enter] をクリックします"
      },
      "group_created": {
        "goals_section": {
          "assessment_test_desc": "クラスが評価を完了する必要がある日付を設定してください。"
        }
      }
    },
    "no_groups_desc": "最初のクラスを作成し、学習者をクラスに招待しましょう。",
    "groups_desc": "クラス・教師・学習者のELSAへのアクセスを管理します。",
    "get_set_up": {
      "title": "設定する",
      "title_note": "このオンボーディングチェックリストを使用して、設定を開始しましょう。",
      "step1": {
        "title": "共同管理者の追加",
        "description": "アカウントに1人または複数の共同管理者を追加しましょう。管理者は、チームの作成・目標やリマインダーの設定、学習者の招待、レポートの確認を行うことができます。管理者は必要に応じていつでも追加・削除することができます。",
        "button": "管理者の追加"
      },
      "step2": {
        "title": "先生を招待する",
        "description": "チームを管理する教師を追加しましょう。",
        "button": "先生を招待する"
      },
      "step3": {
        "title": "クラスの作成",
        "description": "クラスを作成し,教師を割り当て,クラスの目標を設定することができます。",
        "button": "クラスの作成"
      },
      "step4": {
        "title": "学習者を招待する",
        "description": "学習者をチームに招待するには,提案されたフォームを使って学習者のメールアドレスを手動で追加またはアップロードします。招待された学習者は,ELSAに登録することができます",
        "button": "学習者を招待する"
      }
    },
    "charts": {
      "organization_performance": "学校のパフォーマンス",
      "distribution_by_learners_title": "学習者の分布",
      "distribution_by_learners_desc": "ELSAのスコア範囲に基づいて計算されています。",
      "teamview_leaderboard_org_label": "クラスの表示",
      "team_study_goal": "クラスの学習目標",
      "group": {
        "average_elsa_score_historical_progress_title": "平均ELSAスコアの進捗状況",
        "average_elsa_score_historical_progress_desc": "クラスの平均Elsaスコアの経時変化",
        "average_elsa_score_desc": "あなたのクラスの学習者の結果に基づいて",
        "average_elsa_score_title": "クラスの平均レベル",
        "learning_effort_decs": "練習時間数と練習レッスン数の比較",
        "learning_effort_title": "クラスの学習努力",
        "pentagon_title": "ELSAスコアのスキル別内訳",
        "pentagon_desc": "あなたのクラスの学習者の結果に基づく",
        "ielts_title": "IELTSスピーキングスコア分布",
        "ielts_desc": "EPSスコアをもとに予測しています。これは、IELTSやIDPによって承認または保証されたものではありません。",
        "no_ielts_data_title": "学習者からのデータがまだ十分ではありません。",
        "no_ielts_data_desc": "スピーキングのスコア予測をするためには、アセスメントテストを受けるか、より多くのレッスンを練習するように学習者に通知してください。",
        "performance_title": "クラスのパフォーマンス",
        "highest_average_score_skills_title": "クラスの実績"
      },
      "organization": {
        "average_elsa_score_historical_progress_title": "平均ELSAスコアの進捗状況",
        "average_elsa_score_historical_progress_desc": "組織の平均ELSAスコアの経時変化",
        "average_elsa_score_title": "学校の平均レベル",
        "average_elsa_score_desc": "学校の生徒の結果に基づく",
        "learning_effort_decs": "練習した時間数 vs 練習したレッスン数",
        "learning_effort_title": "組織の学習の取り組み",
        "pentagon_title": "スキル別ELSAスコアの内訳",
        "pentagon_desc": "学校の生徒の結果に基づく",
        "ielts_title": "IELTSスピーキングスコアの分布",
        "ielts_desc": "EPSスコアに基づいて予測しています。これは、IELTSまたはIDPによって承認または推奨されているものではありません。",
        "no_ielts_data_title": "まだ生徒のデータが不十分です。",
        "no_ielts_data_desc": "スピーキングスコアの予測を得るために、評価テストを受けるか、より多くのレッスンを練習するよう学習者に通知してください。",
        "performance_title": "組織のパフォーマンス",
        "highest_average_score_skills_title": "組織の成果"
      },
      "learner_col_label": "クラス名",
      "tooltips": {
        "group_eps": "選択した期間における、クラスの生徒のデータから計算された最新の平均スコア",
        "group_durations": "選択した期間における、クラスが練習した合計時間（HH:MM:SS形式）",
        "group_lessons_total": "クラスが練習したレッスンの総数"
      }
    },
    "study_sets": {
      "organization": "組織",
      "group": "クラスのみ",
      "public": "公開",
      "assign_to_group": "クラスに割り当て",
      "assign_to_groups": "クラスに割り当てられました",
      "assign_to_another_group": "別のクラスに割り当て",
      "recent_assigned_group": "最近割り当てられたクラス",
      "assigned_groups": "割り当てられたクラス",
      "no_study_sets_desc": "学習セットは,クラスに割り当てることができるカスタマイズされたレッスンです。",
      "modals_delete_title": "選択した学習セットを削除すると,現在のクラスに影響が及びます。続行しますか？",
      "information_assignments_assigned_to": "お探しのクラスが見つかりませんか？そのクラス名を入力して,Enterキーを押してください。",
      "information_study_set_shareable_to": "クラスのみ:学習セットは、その学習セットを割り当てたクラスの学習者のみに表示されます。\n私の組織:学習セットは、組織のメンバー（例:管理者や先生）に表示されます。\n公開:学習セットは、すべてのELSAユーザーに表示されます。"
    },
    "assignments": {
      "modals_delete_title": "選択した課題を削除しますか？",
      "modals_delete_decs": "それらは進捗状況も含め,生徒のデバイスから削除されます。",
      "modals_delete_detail_title": "この課題を削除しますか？",
      "modals_delete_detail_decs": "進捗状況も含め、学習者のデバイスから削除されます。",
      "no_assignments_yet": "クラスにはまだ課題がありません"
    },
    "homework_library": {
      "assigned_group": "割り当てられたクラス"
    },
    "groups_col_label": ""
  },
  "elsa_goals": {
    "goals": "最高の発音アプリを使って,生徒の英語スキルアップを手助けします:",
    "goal1": "柔軟にクラスの予定を組む",
    "goal2": "進捗レポートを見る",
    "goal3": "学習者を個別に、グループに招待する"
  },
  "navbar": {
    "dashboard": "ダッシュボード",
    "classes": "クラス",
    "teachers": "先生",
    "students": "学習者",
    "account": "アカウント",
    "my_profile": "マイプロフィール",
    "manage": "組織リスト",
    "logout": "ログアウト",
    "hello": "こんにちは",
    "organizations": "組織",
    "org_current": "現在の組織",
    "Language": "言語"
  },
  "teacher_info": {
    "profile": "プロフィール",
    "first_name": "名",
    "last_name": "姓",
    "email": "メールアドレス",
    "username": "ユーザー名",
    "phone_number": "電話番号",
    "user_roles": "ユーザーの役割",
    "department": "部門",
    "title": "役職",
    "user_role": "ユーザーの役割",
    "overview": "概要",
    "show_all_classes": "すべてのクラスを表示する"
  },
  "student_info": {
    "overview": "概要",
    "profile": "プロフィール"
  },
  "user_profile": {
    "title": "",
    "dont_belong_organization": "あなたはどの組織にも所属していません。",
    "join_organization": "組織に加入",
    "create_organization": "組織を作成",
    "withdraw_from_organization": "先生",
    "your_profile": {
      "title": "あなたのプロフィール",
      "first_name": "名",
      "last_name": "姓",
      "user_name": "ユーザー名",
      "email": "メールアドレス",
      "not_verified": "確認されていません",
      "phone_number": "電話番号",
      "did_not_receive": "確認メールが届かない場合",
      "resent_email": "確認メールの再送",
      "modals": {
        "edit_profile": {
          "update_success": "ユーザーは正常にアップデートされました。",
          "update_warning": "ユーザーは正常にアップデートされませんでした。",
          "title": "プロフィールを編集する",
          "upload_image": {
            "label": "画像をアップロードする"
          },
          "first_name": {
            "label": "名",
            "placeholder": "名を入力してください",
            "validation_msg": "名を入力してください"
          },
          "last_name": {
            "label": "姓",
            "placeholder": "姓を入力してください",
            "validation_msg": "姓を入力してください"
          },
          "email": {
            "label": "メールアドレス",
            "placeholder": "メールアドレスを入力してください。",
            "validation_msg": "正しいメールアドレスを入力してください。"
          },
          "user_name": {
            "label": "ユーザー名",
            "placeholder": "ユーザー名を入力してください"
          },
          "phone": {
            "label": "電話番号",
            "placeholder": "+1-000-000-0000",
            "code_placeholder": "コード"
          },
          "save": "保存する",
          "cancel": "キャンセル"
        },
        "confirm_new_email": {
          "title": "新しいメールアドレスの確認を行ってください。",
          "message": "確認メールをお送りしました。新しいメールアドレスの確認を行ってください。",
          "button_label": "了解しました"
        }
      }
    },
    "change_password": {
      "title": "パスワードを変更する",
      "password": "パスワード",
      "modals": {
        "title": "パスワードを更新してください",
        "current_password": {
          "label": "現在のパスワード",
          "placeholder": "現在のパスワードを入力してください"
        },
        "new_password": {
          "label": "新しいパスワード",
          "placeholder": "8文字以上入力してください"
        },
        "confirm_new_password": {
          "label": "新しいパスワードを確認する",
          "placeholder": "8文字以上入力してください"
        },
        "save": "保存する",
        "cancel": "キャンセル",
        "change_pass_elsa": "ELSAアプリを使ってパスワードを変更してください。",
        "help_text": "ポータルに簡単にアクセスできるよう,アカウントに新しいパスワードを設定することをお勧めします。",
        "button_text": "パスワードを更新する",
        "password_validation": {
          "long": "8文字以上である必要があります",
          "lowercase": "小文字を1つ含める必要があります",
          "uppercase": "大文字を1つ含める必要があります",
          "number": "数字を1つ含める必要があります",
          "number_or_special_char": "１文字の数字、まはた１文字の特殊文字が含まれていることの必要があります @!\"#$%&'()*+,-./:;<=>?",
          "repwd": "パスワードを修正してください",
          "correctpwd": "パスワードを修正してください",
          "match": "確認パスワードはパスワードと一致する必要があります。",
          "please_input": "パスワードを入力してください",
          "input_confirm": "確認パスワードを入力してください。"
        }
      },
      "message": "パスワードが正常に更新されました"
    },
    "your_organizations": {
      "title": "あなたの組織",
      "modals": {
        "title": "{name}から退会する",
        "admin": {
          "message_1": "{name}から退会しますか？",
          "message_2": "あなたは{name}の唯一の管理者です。この組織から退会するには、他の誰かをアカウント所有者に招待してください。"
        },
        "teacher": {
          "message_1": "{name}から退会しますか？現在のプロライセンスへのアクセスが失われます。",
          "message_2": "あなたは{numberOfClasses}クラスに割り当てられた先生です。組織から退会するには,組織の管理者に連絡して,その役割から削除してもらってください。"
        },
        "student": {
          "message_1": "脱退すると,{name}に再度加入するための新しい招待が必要になります。",
          "message_2": "{name}から退会しますか？現在のプロライセンスへのアクセスが失われます。"
        },
        "confirm": "はい、退会します。",
        "cancel": "いいえ、キャンセルします。",
        "got_it": "了解しました。"
      }
    },
    "social": {
      "title": "ソーシャル",
      "modals": {
        "title": "パスワードを入力する",
        "subtitle": "FacebookがなくてもELSAアカウントにアクセスできるよう,パスワードを入力してください",
        "password": {
          "label": "新しいパスワード",
          "placeholder": "新しいパスワードを入力する",
          "validation_msg": "パスワードを挿入する",
          "not_match": "2つの入力が一致しません！"
        },
        "repeat_password": {
          "label": "新しいパスワードを再入力する",
          "placeholder": "新しいパスワードを再入力する"
        },
        "save": "保存する",
        "cancel": "キャンセル"
      }
    },
    "delete_account": {
      "button": "アカウントを削除する",
      "modals": {
        "title": "アカウントを削除する",
        "warning": "{organizationName}から退会しますか？その場合、以下を入力してください。",
        "terms_and_conditions": "履歴データと現在のライセンスにアクセスできなくなることを理解しています。",
        "password": "パスワード",
        "delete_account": "アカウントを削除する",
        "cancel": "キャンセル",
        "terms_validation_msg": "削除条件を承諾してください",
        "password_validation_msg": "パスワードを入力してください"
      }
    }
  },
  "login": {
    "title": "ELSAパートナーポータルへようこそ",
    "accept_invitation": "ELSAアカウントにログインして,{organizationName}からの招待を承諾してください。",
    "email_field": {
      "label": "メールアドレス",
      "placeholder": "メールアドレスを入力する",
      "validation_msg": "正しいメールアドレスを入力してください。",
      "validation_msg_1": "メールアドレスを入力してください。",
      "callback_msg": "メールアドレスを入力してください。"
    },
    "password_field": {
      "label": "パスワード",
      "placeholder": "パスワードを入力してください",
      "validation_msg": "パスワードを入力してください"
    },
    "forgot_password": "パスワードをお忘れですか？",
    "login_and_accept_invitation": "ログインして招待を承諾する",
    "dont_have_account": "アカウントをお持ちではないですか？",
    "create_account": "サインアップ",
    "login": "サインイン",
    "first_login": "ログイン",
    "invalid_token": "招待は期限が切れているか、無効です。",
    "pic_title": "最高の発音アプリを使って、学習者の英語スキルアップを手助けします。",
    "pic_text": "予定を柔軟に組む・進捗レポートを見る・個別に又はグループとして学習者を招待する。",
    "title_note": "ELSAパートナーログインをお使いください",
    "payment_first_login_msg": "購入確認Eメールに記載されているパスワードを使って,管理者アカウントにログインしてください。"
  },
  "confirm_account": {
    "title": "アカウントの確認",
    "check_inbox": "確認Eメールをお送りしました。受信トレイを確認し,アカウントの確認を行ってください。",
    "didnt_receive": "届いていませんか？",
    "resend_confirmation": "確認Eメールを再送する",
    "got_it": "了解しました"
  },
  "resend_confirmation": {
    "title": "確認Eメールの再送",
    "send_confirmation": "新しい確認Eメールをお送りします。Eメールアドレスが正しいことを確認してください。",
    "email_field": {
      "label": "Eメール",
      "placeholder": "Eメールを入力",
      "format_validation_msg": "正しいEメールアドレスを入力してください",
      "validation_msg": "Eメールを入力してください"
    },
    "resend_email": "Eメールの再送"
  },
  "recover_password": {
    "title": "パスワードを忘れた",
    "enter_email_to_reset": "Eメールアドレスを入力すると,パスワードをリセットするためのリンクが送信されます",
    "reset_pass_elsa": "ELSAアプリを使ってパスワードをリセットしてください。",
    "email_field": {
      "label": "Eメールアドレス",
      "placeholder": "Eメールアドレスを入力する"
    },
    "reset_password": "パスワードのリセット",
    "sent_email_check_inbox": "Eメールをお送りしました。受信トレイを確認し,パスワードのリセットを行ってください。",
    "got_it": "了解しました",
    "please_input_email": "Eメールを入力してください",
    "input_correct_email": "正しいEメールアドレスを入力してください"
  },
  "reset_password_modal": {
    "title": "パスワードを更新する",
    "enter_your_password": "新しいパスワード",
    "button_text": "パスワードを更新する",
    "new_password_field": {
      "label": "新しいパスワード",
      "placeholder": "8文字以上入力してください"
    },
    "confirm_password_field": {
      "label": "新しいパスワードを確認する",
      "placeholder": "8文字以上入力してください"
    },
    "desc": "ポータルに管理者としてアクセスできるよう,新しいパスワードを設定することをお勧めします。"
  },
  "sign_up": {
    "title": "アカウントの作成",
    "sign_up": "アカウントを作成する",
    "first_name_field": {
      "label": "名",
      "placeholder": "あなたの名は？",
      "validation_msg": "名を挿入してください"
    },
    "last_name_field": {
      "label": "姓",
      "placeholder": "あなたの姓は？",
      "validation_msg": "姓を挿入してください"
    },
    "email_field": {
      "label": "Eメール",
      "placeholder": "you@example.com",
      "validation_msg": "Eメールを入力してください",
      "correct_validation_msg": "正しいEメールアドレスを入力してください"
    },
    "password_field": {
      "label": "パスワード",
      "placeholder": "パスワードを入力してください",
      "validations": {
        "long": "8文字以上である必要があります",
        "lowercase": "小文字を1つ含める必要があります",
        "uppercase": "大文字を1つ含める必要があります",
        "number": "数字を1つ含める必要があります",
        "number_or_special_char": "１文字の数字、まはた１文字の特殊文字が含まれていることの必要があります @!\"#$%&'()*+,-./:;<=>?",
        "correct_newpwd": "パスワードを修正してください",
        "pwd_match": "確認パスワードはパスワードと一致する必要があります。",
        "input_confirm_pwd": "確認パスワードを入力してください。",
        "input_pwd": "パスワードを入力してください"
      }
    },
    "confirm_password_field": {
      "label": "パスワードを確認する",
      "placeholder": "確認パスワードを入力してください"
    },
    "company_name_field": {
      "label": "会社名",
      "placeholder": "会社名を入力してください",
      "validation_msg": "会社名を挿入してください"
    },
    "company_type_field": {
      "label": "会社タイプ",
      "placeholder": "会社タイプを入力してください",
      "validation_msg": "会社名を挿入してください"
    },
    "signup_accept_invitation": "サインアップして招待を承諾する",
    "invitation_code": "招待コードをお持ちですか？",
    "tooltip_message": "招待コードをお持ちなら,それをここに入力してください。",
    "by_signing_up_to_elsa": "ELSAにサインアップすることで,以下に同意することとなります:",
    "to_our": "",
    "already_have_an_account": "すでにアカウントをお持ちですか？",
    "code_is_not_complete": "コードが不完全です",
    "company_type": {
      "education": "教育",
      "non_education": "教育以外"
    }
  },
  "verify_facebook_info_modal": {
    "title": "情報を確認する",
    "save_continue": "保存して続行する",
    "first_name_field": {
      "label": "名",
      "placeholder": "名"
    },
    "last_name_field": {
      "label": "姓",
      "placeholder": "姓"
    },
    "email_field": {
      "label": "Eメールアドレス",
      "placeholder": "Eメールアドレスを入力",
      "validation_msg": "正しいEメールアドレスを入力してください"
    }
  },
  "organizations": {
    "groups": "グループ",
    "users": "ユーザー",
    "table": {
      "user_email": "Eメールアドレス",
      "username": "名前",
      "titleDept": "役職 / 部署",
      "roles": "役割",
      "actions": "操作",
      "empty": "ユーザーが見つかりません",
      "empty_admin": "管理者が見つかりません",
      "empty_student": "学習者が見つかりません",
      "empty_teacher": "教師が見つかりません",
      "role": {
        "default_admin": "既定の管理者",
        "associate_admin": "共同管理者"
      }
    },
    "users_section": {
      "invite_users": "ユーザーを招待",
      "invite_by_email": "Eメールで招待",
      "import_users": "ユーザーを複数のグループにインポート",
      "import_elsa_id": "Elsa_Idを複数のグループにインポート",
      "share_code": "コードを取得",
      "share_link": "リンクを共有",
      "share_qr_code": "QRコードを共有",
      "add_to_group": "グループに追加",
      "add_to_class": "クラスに追加",
      "revoke_license": "ライセンスを取消",
      "enable_license": "ライセンスを有効化",
      "disable": "無効化",
      "delete": "削除",
      "no_users": "あなたの会社に参加するユーザーを招待",
      "no_users_1": "まだユーザーはいません。",
      "no_users_2": "ユーザーを追加するか,または組織をユーザーに知らせましょう。",
      "select_role": "役割を選択",
      "user_profile": {
        "user_details": {
          "title": "ユーザーの詳細"
        },
        "user_roles": {
          "title": "ユーザーの役割"
        }
      },
      "enable_license_message": "プロライセンスを{firstName}{lastName}に発行しました",
      "modals": {
        "export_report": {
          "message": ""
        },
        "share_qr_code": {
          "title": "QRコードを共有",
          "print_code": "以下のQRコードを印刷",
          "share_with_users": "ユーザーにこれを伝え,スキャンして組織に参加してもらいましょう。",
          "print": "印刷",
          "no_cancel": "取消"
        },
        "share_link": {
          "title": "リンクを共有",
          "copy_link": "リンクをコピー",
          "got_it": "分かりました！",
          "cancel": "取消",
          "title_text": "リンクを共有",
          "link_copied": "リンクをクリップボードにコピーしました"
        },
        "share_code": {
          "title": "コードを取得",
          "share_the_following_code": "コードを生成",
          "user_can_join": "ユーザーにコードを伝えて,これを利用して組織に参加してもらいましょう。",
          "generate_code": "コードを生成",
          "done": "完了"
        },
        "invite_users": {
          "copy_and_paste": "Eメールアドレスをコピー＆ペースト",
          "title": "複数の学習者を招待",
          "title_single": "学習者を招待",
          "add_learner": "学習者を追加",
          "select_team_placeholder": "チームを選択",
          "select_role_label": "ユーザーの役割",
          "copy_paste_emails": "Eメールアドレスをコピー＆ペースト",
          "invite_users": "ユーザーを招待",
          "add_email": "複数のEメールアドレスを入力（カンマで区切る）",
          "success": "ユーザーがユーザーリストに追加されました",
          "consent": "同意する",
          "consent1": "ユーザーを{organizationName}に自動登録",
          "assign_team": "チームを割り当て（任意）",
          "assign_elsa_access": "ELSA Accessを割り当て",
          "select_role_placeholder": "",
          "email_validate_message": "不正なEメールを確認してください",
          "select_role_validate_msg": "役割を選択",
          "add_multiple_learners": "複数の学習者を追加"
        },
        "invite_multiple_users": {
          "title": "学習者を招待"
        },
        "edit_user": {
          "update_success": "更新成功",
          "title": "役割ユーザーの編集",
          "user_title": "役職の選択",
          "user_title_placeholder": "役職",
          "department": "部署を選択",
          "department_placeholder": "部署",
          "department_validation_msg": "部署を入力してください",
          "title_validation_msg": "役職を入力してください",
          "role_validation_msg": "役割を選択してください"
        },
        "disable": {
          "title": "{numberOfAccounts}件のユーザーアカウントを無効化",
          "message": "{numberOfAccounts}人のユーザーに関するプロライセンスを取り消してもよろしいですか？",
          "confirm": "はい,取り消します",
          "cancel": "いいえ,キャンセルします"
        },
        "delete": {
          "title": "ユーザーを組織から削除",
          "message": "{numberOfAccounts}人のユーザーを組織から削除してもよろしいですか？",
          "confirm": "はい,削除します",
          "cancel": "いいえ,キャンセルします"
        },
        "delete_from_class": {
          "title": "ユーザーをチームから削除",
          "message": "{numberOfAccounts}人のユーザーをチームから削除してもよろしいですか？",
          "confirm": "はい,削除します",
          "cancel": "いいえ,キャンセルします"
        },
        "assign_license": {
          "title": "ライセンスをユーザーに割り当て",
          "message": "{licenseDisplayName}ライセンスを{userDisplayName}に割り当ててもよろしいですか？",
          "confirm": "はい,割り当てます",
          "cancel": "いいえ,キャンセルします"
        },
        "invite_multiple": {
          "email_validation_msg": "正しいEメールアドレスを入力してください",
          "firstname_validation_msg": "名前を入力してください",
          "lastname_validation_msg": "名字を入力してください",
          "add_single_learner": "学習者を1人追加"
        },
        "invite_learners": {
          "email_validate_msg": "正しいEメールアドレスを入力してください",
          "first_name_validation_msg": "名前を入力してください",
          "last_name_validation_msg": "名字を入力してください"
        },
        "invite_teacher": {
          "first_name": "名前",
          "last_name": "名字",
          "email_validation_msg": "正しいEメールアドレスを入力してください",
          "first_name_validation_msg": "名前を入力してください",
          "last_name_validaion_msg": "名字を入力してください"
        }
      },
      "popovers": {
        "groups": {
          "title": "グループに追加",
          "add_group": "グループを追加",
          "manage_groups": "グループを管理"
        },
        "classes": {
          "title": "クラスに追加",
          "new_class": "新しいクラス"
        },
        "roles": {
          "title": "役割を編集"
        },
        "user": {
          "title": "ユーザー情報を編集"
        }
      }
    },
    "invite_users": {
      "title": "ユーザーを招待",
      "subtitle": "あなたの会社に参加するユーザーを招待",
      "import_users": "Eメールアドレスのリストをインポート",
      "import_users_classes": "Eメールアドレスのリストを複数グループにインポート",
      "share_link": "リンクを共有",
      "mail_invite": "Eメールアドレスをコピー＆ペースト",
      "multiple_mail_invite_with_enrolled": "{numberOfInvites}人のユーザーがグループに登録されました",
      "multiple_mail_invite": "{numberOfInvites}人のユーザーが招待されました",
      "multiple_mail_to_invite": "{numberOfInvites}人のユーザーが招待されます",
      "import": {
        "elsa-title": "ElsaユーザーIDのリストをインポート",
        "title": "Eメールアドレスのリストをインポート",
        "subtitle": "リストをインポート",
        "instructions": "ここにファイルをドラッグ＆ドロップしてアップロードしてください。",
        "files": "{fileCount}件のファイルがアップロードされました",
        "instructions2": "テンプレートを次の形式でダウンロード:",
        "instructions3": "以下にドラッグ＆ドロップしてインポート",
        "get_template": "テンプレートを取得",
        "get_template_xlsx": "MS Excel形式",
        "get_template_csv": "CSV形式",
        "browse_files": "ファイルを閲覧"
      },
      "mail": {
        "title": "Eメールアドレスをコピー＆ペースト"
      },
      "confirmation_title": "確認",
      "select_a_membership": "メンバーシップを選択",
      "available_licenses": "利用可能なライセンス:",
      "click_to_assign": "クリックしてライセンスを学習者に割り当て",
      "assign_all": "全て割り当て",
      "clear_all": "全て消去",
      "assign_license": {
        "table": {
          "email": "Eメール",
          "first_name": "名前",
          "last_name": "名字",
          "class": "クラス",
          "license": "ライセンス"
        },
        "title": "ライセンスを割り当て",
        "invite_only": "招待のみ,ライセンス不要"
      }
    },
    "edit_org_teacher": {
      "first_name": "名前",
      "last_name": "名字",
      "first_name_validation_msg": "名前を入力してください",
      "last_name_validation_msg": "名字を入力してください"
    },
    "import_user": {
      "title": "ユーザーをインポート"
    },
    "add_user_to_team": "{0}をチームに追加",
    "join_org": {
      "enter_invitation_code": "招待コードを入力",
      "email_validation": "正しいEメールアドレスを入力してください"
    },
    "plan": {
      "title": "グループ • {0} • プラン & 支払い",
      "plan_title": "プラン & 支払い",
      "learners": "{0}人の学習者",
      "user_month": "{0}/ユーザー/月",
      "redeem_by": "使用期限:",
      "used": "使用済:",
      "licenses": "{0}件のライセンス",
      "contract_to_use_license_s": "{0}件のライセンス",
      "to_use": "使用可:",
      "activated": "（アクティベート済み）",
      "order_id": "注文ID",
      "billing_cycle": "請求サイクル:",
      "purchase_date": "購入日:",
      "next_billing_date": "次の請求日:",
      "payment_method": "支払い方法:",
      "next_billing_amount": "次の請求金額:",
      "buy_more_packages": "追加のパッケージを購入",
      "billing_history": "請求履歴",
      "order_number": "注文番号",
      "purchase_date_table_header": "購入日",
      "plan_type": "プランの種類",
      "amount": "金額",
      "number_of_licenses": "ライセンス数",
      "transaction_type": "取引種別",
      "elsa_pro_1_year": "ELSA Pro 1年間",
      "elsa_pro_6_months": "ELSA Pro 6か月間",
      "elsa_pro_3_months": "ELSA Pro 3か月間",
      "elsa_pro_1_month": "ELSA Pro 1か月間",
      "annual": "年間",
      "semi_annual": "半年",
      "quarterly": "3か月",
      "medium": "ミディアム",
      "lite": "ライト",
      "yearly": "年1回",
      "every_6_months": "6か月ごと",
      "every_3_months": "3か月ごと",
      "every_1_month": "1か月ごと"
    }
  },
  "table_row": {
    "actions": {
      "remove_from_group": "グループから削除",
      "add_to_class": "クラスに追加",
      "disable": "無効化",
      "delete": "削除"
    }
  },
  "organization_profile": {
    "title": "プロフィール",
    "admins": "管理者",
    "date_joined": "参加日",
    "add_associate_admin": "共同管理者を追加",
    "pending_request": "未対応のリクエスト",
    "organization_name": "組織名",
    "organization_username": "組織ユーザー名",
    "organization_type_industry": "組織の種類/業種",
    "phone": "電話番号",
    "address": "住所",
    "affiliate": "会員",
    "admin_actions": {
      "remove_from_admin": "削除",
      "edit_user": "ユーザーを編集",
      "remove_from_organization": "削除",
      "change_default_admin": "既定の管理者に変更",
      "change_associate_admin": "共同管理者に変更",
      "user_id_only_admin": "組織で唯一の管理者は削除できません。"
    },
    "remove_admin_modal": {
      "title": "管理者を削除",
      "yes_remove": "削除",
      "no_cancel": "取消",
      "add": "追加",
      "msg_no_longer_admin": "{0}は既定の管理者としてアカウントを管理する権限が無くなります。"
    },
    "add_role_to_user": {
      "title": "役割を変更",
      "message": "{userAssociateName}の役割を{roleDisplayName}に変更してもよろしいですか？",
      "yes_associate": "変更",
      "no_cancel": "取消"
    },
    "invite_admin_modal": {
      "invite_success": "招待が送信されました。",
      "remove_invite_success": "招待を削除しました",
      "remove_invite_fail": "招待の削除に失敗しました",
      "confirm_remove_invitation": "この招待を削除しますか？",
      "title": "新しい管理者を招待",
      "email_field": {
        "label": "メールアドレス",
        "placeholder": "メールアドレスを入力"
      },
      "invite_button": "招待",
      "cancel_button": "取消",
      "invite_admin_desc": "共同管理者は,チームの作成,目標の設定,学習者の招待しかできません。アカウント,契約,プランと支払いへのアクセス権はありません。",
      "first_name": "名前",
      "last_name": "名字",
      "email_validation_msg": "正しいEメールアドレスを入力してください",
      "name_validation_msg": "名前を入力してください",
      "last_name_validation_msg": "名字を入力してください"
    },
    "delete_disable_organization_modal": {
      "title_delete": "削除",
      "title_disable": "無効化",
      "title_enable": "有効化",
      "password_field": {
        "label": "パスワード",
        "placeholder": "パスワードを入力",
        "validation_msg": "パスワードを入力してください"
      },
      "delete_button": "組織を削除",
      "disable_button": "無効にします",
      "enable_button": "有効にします",
      "cancel_button": "取消",
      "delete_terms": "私は,自分の履歴データおよび現在のライセンスにアクセスできなくなることを承知しています。",
      "disable_terms": "私は、有効ライセンスを失うことを承知しています。",
      "are_you_sure_disable": "無効にしてよろしいですか？",
      "are_you_sure_enable": "有効にしてよろしいですか？",
      "are_you_sure_widthraw": "退会してもよろしいですか？",
      "if_so_fill_following": "その場合は,次の情報を提供してください:"
    },
    "edit_organization_modal": {
      "invite_not_send": "組織は作成されましたが,招待を送信できませんでした。",
      "update_success": "組織が更新されました",
      "create_success": "組織が作成されました",
      "create_title": "新しい組織を作成",
      "edit_title": "組織を編集",
      "save": "保存",
      "cancel": "キャンセル",
      "upload_logo_field": {
        "label": "ロゴをアップロード"
      },
      "verified_organization": "組織を認証",
      "enable_organization": "組織を有効にする",
      "disable_organization": "組織を無効にする",
      "delete_organization": "組織を削除する",
      "are_you_sure_disable": "無効にしてもよろしいですか",
      "name_field": {
        "label": "組織名",
        "placeholder": "組織名を入力"
      },
      "code_field": {
        "label": "組織コード",
        "placeholder": "組織コードを入力してください"
      },
      "username_field": {
        "label": "ユーザー名",
        "placeholder": "組織のユーザー名を入力してください"
      },
      "org_type_field": {
        "label": "組織の種類",
        "placeholder": "組織タイプを選択"
      },
      "industry_field": {
        "label": "業界",
        "placeholder": "業界を選択"
      },
      "address_field": {
        "label": "住所",
        "placeholder": "組織の住所を入力してください",
        "validation_msg": "住所を入力してください"
      },
      "phone_field": {
        "label": "電話番号",
        "placeholder": "+1-000-000-0000",
        "validation_msg": "電話番号を入力してください",
        "validation_number_msg": "電話は番号である必要があります"
      },
      "country_field": {
        "label": "国",
        "placeholder": "国を入力してください",
        "validation_msg": "国を選んでください"
      },
      "state_field": {
        "label": "州/県",
        "placeholder": "州/県を入力してください",
        "validation_msg": "州を入力してください"
      },
      "city_field": {
        "label": "市",
        "placeholder": "市を入力してください",
        "validation_msg": "市を入力してください"
      },
      "post_code_field": {
        "label": "郵便番号",
        "placeholder": "郵便番号",
        "validation_msg": "郵便番号を選択してください"
      },
      "owner_field": {
        "label": "組織管理者",
        "placeholder": "メールアドレスを入力",
        "required_validation_msg": "アカウントの所有者を入力してください",
        "email_validation_msg": "無効な所有者のメールアドレスです"
      },
      "affiliate_field": {
        "label": "アフィリエイト",
        "placeholder": "無し"
      },
      "timezone_field": {
        "label": "タイムゾーン",
        "placeholder": "その他/ GMT"
      },
      "learner": {
        "first_name": "下の名前",
        "last_name": "名字",
        "first_name_validation_msg": "下の名前を入力してください",
        "last_name_validation_msg": "名字を入力してください"
      },
      "code": "コード",
      "organization_validation": "組織名を入力してください",
      "_organization_type_validation": "組織のタイプを入力してください",
      "industry_validation": "業界を選んでください"
    }
  },
  "admin": {
    "organizations": {
      "title": "組織",
      "create_new_organization": "新しい組織を作成",
      "import_organizations": "組織をインポート",
      "verify": "認証",
      "table": {
        "verification": "認証",
        "unredeemed_licenses": "未使用のライセンス",
        "not_verified": "検証されていません",
        "verified": "認証済み",
        "organization_name": "組織名",
        "status": "ステータス",
        "licences": "ライセンス",
        "empty": "組織が見つかりません",
        "active": "アクティブ",
        "inactive": "無効",
        "country": "国",
        "created_at": "作成日",
        "expected_renewal": "予想される更新",
        "contract_end": "契約の終了",
        "out_of_total": "{total}のうち"
      },
      "filter_menu": {
        "all": "すべて",
        "active": "アクティブ",
        "disabled": "無効",
        "verified": "認証済み",
        "filter_by_country": "国でフィルタリング"
      }
    },
    "invite_admin": "管理者を招待"
  },
  "organization_page": {
    "organizations": "組織",
    "disable": "無効にする",
    "delete": "削除",
    "menu": {
      "licences": "ライセンス",
      "users": {
        "title": "ユーザー",
        "all_users": "すべてのユーザー",
        "employees": "従業員",
        "leads": "チームリーダー",
        "admins": "管理者"
      },
      "groups": "グループ",
      "profile": "プロフィール",
      "contract": "契約",
      "admins": "管理者"
    }
  },
  "disable_organization_modal": {
    "title": "無効にする",
    "yes_disable": "はい,無効にします",
    "no_cancel": "いいえ,キャンセルします",
    "are_you_sure": "組織Aを無効にしてもよろしいですか？組織が無効になっている間,ユーザーはライセンスにアクセスできなくなります。"
  },
  "onboarding": {
    "welcome": "ELSAへようこそ",
    "welcome_subtitle": "ELSAの旅をご案内できるように,あなた自身についてもう少し教えてください。",
    "who_are_you": "あなたはどのような人ですか？",
    "select_option": "以下のオプションのいずれかを選択してください",
    "school": "学校",
    "school_admin": "学校管理者",
    "company": "企業",
    "company_admin": "企業管理者",
    "teacher": "教師",
    "student": "学習者",
    "continue": "続行",
    "you_do_not_belong_to_any_org": "あなたはどの組織にも属していません"
  },
  "school": {
    "setup_school": {
      "successfully_created": "あなたの学校は正常に作成されました。",
      "setup_your_school": "学校をセットアップする",
      "invite_students_teachers": "学習者と教師を組織に招待します。",
      "create_your_first_class": "最初の授業を作りましょう！",
      "create_class": "クラスを作成",
      "invite_teachers": "教師を招待",
      "invite_students": "学習者を招待",
      "teacher": "教師",
      "continue": "続行"
    },
    "create_edit_modal": {
      "title": "学校を作成",
      "create": "作成",
      "cancel": "キャンセル",
      "name_field": {
        "label": "学校名",
        "placeholder": "学校名を入力",
        "validation_msg": "学校名を入力してください"
      },
      "username_fields": {
        "label": "ユーザー名",
        "placeholder": "学校のユーザー名を入力してください",
        "validation_msg": "学校のユーザー名を入力してください"
      },
      "type_field": {
        "label": "学校のタイプ",
        "placeholder": "学校のタイプを選択"
      },
      "industry_field": {
        "label": "業界",
        "placeholder": "業界を選択",
        "validation_msg": "業界を選んでください"
      },
      "address_field": {
        "label": "住所",
        "placeholder": "学校の住所を選択",
        "validation_msg": "学校の住所を選んでください"
      },
      "phone_field": {
        "label": "電話番号",
        "placeholder": "+1-000-000-0000",
        "code": "コード",
        "validation_msg": "学校の電話番号を選んでください"
      },
      "country_field": {
        "label": "国",
        "placeholder": "国を入力してください",
        "validation_msg": "学校の国を選んでください"
      },
      "state_field": {
        "label": "都道府県",
        "placeholder": "都道府県を入力してください",
        "validation_msg": "学校の都道府県を選んでください"
      },
      "city_field": {
        "label": "市",
        "placeholder": "市を入力してください",
        "validation_msg": "学校の市を選んでください"
      },
      "post_code_field": {
        "label": "郵便番号",
        "placeholder": "000-0000",
        "validation_msg": "番号で入力してください。",
        "required_validation_msg": "学校の郵便番号を選択してください",
        "number_validation_msg": "郵便番号は数字である必要があります"
      },
      "school_type": {
        "validation_msg": "学校の種類を選択してください",
        "youtube_type_1": "Youtubeのタイプ1",
        "youtube_type_2": "Youtubeのタイプ2",
        "youtube_industry_1": "Youtubeの業界1",
        "youtube_industry_2": "Youtubeの業界2"
      }
    }
  },
  "company": {
    "setup_company": {
      "successfully_created": "あなたの会社の作成が完了しました。",
      "setup_your_company": "会社をセットアップ",
      "invite_students_teachers": "学習者と教師を会社に招待します。",
      "create_class": "クラスを作成する",
      "invite_teachers": "教師を招待",
      "invite_students": "学習者を招待",
      "continue": "続行"
    },
    "create_edit_modal": {
      "title": "企業を作成",
      "create": "作成",
      "cancel": "キャンセル",
      "name_field": {
        "label": "会社名",
        "placeholder": "会社名を入力してください",
        "validation_msg": "会社名を入力してください"
      },
      "username_field": {
        "label": "会社のユーザー名",
        "placeholder": "会社のユーザー名を入力してください",
        "validation_msg": "会社のユーザー名を入力してください"
      },
      "type_field": {
        "label": "会社の種類",
        "placeholder": "会社の種類を入力してください",
        "validation_msg": "会社の種類を選択してください"
      },
      "industry_field": {
        "label": "業界のタイプ",
        "placeholder": "業界を入力してください",
        "validation_msg": "業界を選んでください"
      },
      "address_field": {
        "label": "住所",
        "placeholder": "学校の住所を入力してください",
        "validation_msg": "会社の住所を選択してください"
      },
      "phone_field": {
        "label": "電話番号",
        "placeholder": "+1-000-000-0000",
        "code": "コード",
        "code_validation_msg": "会社の電話を選んでください",
        "validation_msg": "電話は番号である必要があります"
      },
      "country_field": {
        "label": "国",
        "placeholder": "国を入力",
        "validation_msg": "会社の国を選択してください"
      },
      "state_field": {
        "label": "都道府県",
        "placeholder": "都道府県を入力",
        "validation_msg": "会社の都道府県を選択してください"
      },
      "city_field": {
        "label": "市",
        "placeholder": "市を入力",
        "validation_msg": "会社の市を選択してください"
      },
      "post_code_field": {
        "label": "郵便番号",
        "placeholder": "000-0000",
        "required_validation_msg": "会社の郵便番号を選択してください",
        "number_validation_msg": "郵便番号は数字である必要があります"
      },
      "company_type": {
        "youtube_type_1": "Youtubeの種類1",
        "youtube_type_2": "Youtubeの種類2",
        "youtube_industry_1": "Youtubeの業界1",
        "youtube_industry_2": "Youtubeの業界2"
      }
    }
  },
  "teacher": {
    "are_you_part_of_organization": "あなたは組織の一員ですか？",
    "select_one_options": "以下のオプションのいずれかを選択してください",
    "yes": "はい",
    "no": "いいえ",
    "teach_myself": "一人で教えています",
    "continue": "続行",
    "do_you_have_invitation_code": "招待コードはありますか？",
    "enter_the_code": "組織に参加するためのコードを入力してください"
  },
  "student": {
    "are_you_part_of_organization": "あなたは組織の一員ですか？",
    "select_one_options": "以下のオプションのいずれかを選択してください",
    "yes": "はい",
    "no": "いいえ",
    "learning_myself": "自分で学習しています",
    "continue": "続行",
    "do_you_have_invitation_code": "招待コードはありますか？",
    "edit_learner": "学習者を編集",
    "remove_learner": "学習者を削除",
    "theres_no_learner": "組織にはまだ学習者がいません",
    "invite_your_team": "チームメンバーを招待して,ELSAで学習を開始できるようにします",
    "invite_learners": "学習者を招待"
  },
  "setup_organization": {
    "join_your_organization": "組織に参加する",
    "wait_for_admin": "管理者から招待状が送信されるのを待つか,招待状コードを入力してください。",
    "enter_invitation_code": "招待コードを入力してください",
    "continue": "続行",
    "welcome_to_organization": "組織Aへようこそ",
    "you_can_create_own_class": "独自のクラスを作成するか,管理者がクラスに割り当てるのを待つことができます",
    "create_class": "クラスを作成"
  },
  "start_learning": {
    "start_learning": "学習を開始",
    "download_elsa_app": "ELSA Speakアプリをモバイルデバイスにダウンロードします:",
    "or_send_the_email_by_link_sms": "あるいは,メールまたはSMS /テキストメッセージでダウンロードリンクを取得します。",
    "send_email_link": "メールでリンクを送ってください",
    "send_sms_link": "SMSでリンクを送ってください",
    "start_practice": "練習を始める",
    "you_can_download": "アプリをダウンロードして練習を開始できます:",
    "to_join_our_organization": "組織に参加するには,管理者があなたを招待するのを待つか,招待コードを入力してください",
    "enter_invitation_code": "招待コードを入力してください",
    "email_link_sent": "メールでリンクが送信されました",
    "sms_link_sent": "SMSでリンクが送信されました",
    "get_email_link_modal": {
      "title": "メールでリンクを取得する",
      "get_email_link": "メールでリンクを取得する",
      "email_field": {
        "label": "メール",
        "placeholder": "メールアドレスを入力する",
        "validation": "正しいメールアドレスを入力してください"
      },
      "phone_type_field": {
        "label": "電話の種類",
        "placeholder": "電話の種類"
      },
      "success": "メールを送信しました",
      "warning": "メール送信に失敗しました,後ほどやり直してください"
    },
    "send_sms_link_modal": {
      "title": "SMSでリンクを取得する",
      "get_sms_link": "SMSでリンクを取得する",
      "phone_type_field": {
        "label": "電話の種類",
        "placeholder": "電話の種類"
      },
      "phone_field": {
        "label": "電話",
        "placeholder": "+1-000-000-0000",
        "code": "コード",
        "validation_msg": "電話番号は数字で入力してください"
      },
      "success": "SMSを送信しました",
      "warning": "SMSを送信できませんでした,後ほどやり直してください",
      "email_validation_msg": "正しいメールアドレスを入力してください"
    }
  },
  "industries": {
    "aerospace": "航空宇宙",
    "transportation": "運輸",
    "computer_software_internet": "コンピュータ・ソフトウェア・インターネット",
    "telecommunication": "電気通信",
    "food_and_agriculture": "食品・農業",
    "construction": "建設",
    "education": "教育",
    "healthcare": "医療",
    "travel_and_hospitality": "旅行・観光",
    "entertainment_news_media_music": "エンタメ・ニュース・報道",
    "energy": "エネルギー",
    "manufacturing": "製造",
    "fashion_and_clothing": "ファッション・服飾",
    "mining": "採掘",
    "consulting_services": "コンサルティング / サービス",
    "other": "その他"
  },
  "study_sets": {
    "curriculum": "カリキュラム",
    "no_study_sets_yet": "今のところ学習セットはありません",
    "delete_study_set_success": "学習セットの削除に成功しました",
    "delete_study_set_warning": "学習セットの削除に失敗しました",
    "create_study_set": "学習セットを作成",
    "add_study_set": "新しい学習セットを追加",
    "your_study_set": "あなたの学習セット",
    "review_confirm": "見直して確認",
    "copy_of_study_set_name": "{name}のコピー",
    "back": "戻る",
    "study_set": "学習セット",
    "information": "情報",
    "success_class_updated": "学習セットの更新に成功しました",
    "success_class_duplicated": "学習セットの複製に成功しました",
    "assignment_name": "課題名",
    "assigned_to": "割当て先",
    "assign_to": "割当て対象",
    "start_on": "開始",
    "start_time": "開始時刻",
    "start_date": "開始日",
    "due_on": "期限",
    "due_time": "期限時刻",
    "due_date": "期限日",
    "set_reminder": "リマインダーを設定",
    "before_the_due_day": "期限日前に。",
    "before_the_due_date": "期日前に",
    "phrases_count": "アイテム",
    "phrases": "アイテム",
    "assigned_on_date": "{date}に割当て済み",
    "menu": {
      "study_sets": "学習セット",
      "all_assignments": "課題",
      "read_alound": ""
    },
    "table": {
      "search_study_set_name": "学習セット名を検索",
      "study_set_name": "学習セット名",
      "last_updated": "最終更新日",
      "category": "カテゴリー",
      "phrases": "アイテム",
      "shareable_to": "共有対象",
      "edit": "編集",
      "duplicate": "複製",
      "remove": "削除",
      "search_hint": ""
    },
    "form": {
      "study_set_name": "学習セット名",
      "name_your_study_set": "あなたの学習セットに名前を付ける",
      "category": "カテゴリー",
      "input_phrases": "単語・フレーズ・文を入力",
      "shareable_to": "共有対象",
      "phrases": "フレーズ",
      "type_in_phrases_press_enter_to_seperate": "こちらに入力,またはコピー&ペーストします。アイテムを分けるには「;」を使います。 ",
      "cancel": "取り消す",
      "next": "次",
      "more_actions": "さらなるアクション",
      "name_your_assignment": "あなたの課題に名前を付ける"
    },
    "errors": {
      "please_provide_name": "名前を付けてください",
      "please_provide_category": "カテゴリーを選んでください",
      "please_provide_shareable_to": "共有対象を選んでください",
      "please_provide_assignment_name": "課題名を入力してください",
      "please_provide_start_on": "開始日を選んでください",
      "please_provide_due_on": "期限日を選んでください"
    },
    "create_studyset_flow": {
      "save_finish_later": "保存して後で完成する",
      "cancel": "取り消す",
      "save": "保存する",
      "next": "続ける",
      "previous": "戻って編集する",
      "details": "詳細情報"
    },
    "overview": {
      "study_set_name": "学習セット名",
      "shareable": "共有対象",
      "category": "カテゴリー",
      "phrases_count": "アイテムの数",
      "created_by": "作成者",
      "phrases_list_title": "アイテム",
      "phrases_add_success": "このアイテムの追加に成功しました",
      "phrases_add_fail": "このアイテムはあなたの学習セットに追加されませんでした。"
    },
    "modals": {
      "edit_class": {
        "title_save": "クラスを保存してライセンスを割り当てる",
        "description": "クラスの詳細とライセンスの変更を保存してもよろしいですか?"
      },
      "cancel": {
        "title": "本当に退出しますか？",
        "decs": "あなたが行った変更は保存されません。",
        "cancel": "このページに留まる",
        "confirm": "退出する"
      },
      "createSuccess": {
        "message": "新しい学習セットの\n作成に成功しました！",
        "study_set_name_label": "学習セット名",
        "count_of_item_label": "アイテム数の計算",
        "done": "完了",
        "create_another_study_set": "別な学習セットを作成する"
      },
      "createAssignmentSuccess": {
        "new_assignments_status": "新しい課題のステータス",
        "assign_to_class_successfully": "クラスへの割り当てに成功しました！",
        "assignment_name": "課題名",
        "assigned_to": "割当て先",
        "due_date": "期限日"
      },
      "delete": {
        "confirm": "削除する",
        "cancel": "取り消す"
      },
      "addAssignment": {
        "add_assignment": "課題を追加する",
        "choose_study_set": "学習セットを選ぶ",
        "add_study_set": "学習セットを追加する",
        "other_settings": "他の設定"
      },
      "spell_check": {
        "desc": "あなたのアイテムにはエラーがあるようです。\nそれでも続行しますか？",
        "back_to_edit": "戻って編集する",
        "proceed": "続行する"
      }
    },
    "messages": {
      "your_study_set_has_been_created_successfully": "あなたの学習セットの作成に成功しました！",
      "your_study_set_has_been_updated_successfully": "あなたの学習セットの更新に成功しました！"
    },
    "assign_to_class": "クラスに割り当てる",
    "delete": "削除する",
    "remove_the_word": "単語を削除する",
    "add": "追加する",
    "ignore_all": "すべて無視する",
    "replace_all": "すべて置き換える"
  },
  "assignments": {
    "class_assignment": "クラス課題",
    "add_assignment": "課題を追加する",
    "delete_assignment_success": "課題の削除に成功",
    "delete_assignment_warning": "課題の削除に失敗",
    "table": {
      "name": "名前",
      "timeline": "予定表",
      "max_score": "最高点",
      "min_score": "最低点",
      "avg_score": "平均点",
      "submitted_ontime": "期限通り提出",
      "submitted_late": "遅れて提出",
      "missed": "未提出"
    },
    "modals": {
      "no_study_sets": {
        "title": "課題を追加",
        "desc": "あなたのカリキュラムには学習セットがないので,このアクションを実行できません。",
        "action": "今すぐ学習セットを作成する"
      },
      "cancel": {
        "decs_line_1": "あなたは担当の生徒に課題を作成中です。",
        "decs_line_2": "本当に取り消しますか？",
        "continue": "続ける",
        "cancel": "取り消す"
      }
    },
    "messages": {
      "your_assignment_has_been_created_successfully": "課題はあなたの担当学習者に送信されました",
      "your_assignment_has_been_updated_successfully": "あなたの学習セットの更新に成功しました！"
    },
    "details": {
      "back_to_assignment_list": "課題リストに戻る",
      "start_on": "開始日",
      "due_on": "期限日",
      "reminder_sent": "リマインダー",
      "information": "概説",
      "performance": "成績",
      "performance_lesson": "生徒の成績",
      "study_set_name": "学習セット名",
      "count_of_items": "アイテム数の計算",
      "category": "カテゴリー",
      "name": "名前",
      "score": "最高点",
      "date_completed": "最初の完了",
      "overall_result": "総合的な結果",
      "detail_result": "授業の詳細情報",
      "overall_result_overall_score": "課題の総合得点",
      "overall_result_max_score": "最高点",
      "overall_result_average_score": "平均点",
      "overall_result_min_score": "最低点",
      "overall_result_submissions": "提出",
      "overall_result_submissions_out_of": "割合",
      "overall_result_submission_on_time": "期限内",
      "overall_result_submission_late": "期限過ぎ",
      "overall_result_submission_missed": "未提出",
      "detail_result_lesson_name": "授業名",
      "detail_result_results": "結果",
      "performance_name": "名前",
      "performance_score": "最高点",
      "performance_date_complete": "最初の完了",
      "performance_tooltip": {
        "score": "こちらは,学習者が何回も課題をこなした場合の最高点です",
        "date_complete": "こちらは学習者が何度も課題をこなした場合の,最初の完了日です"
      },
      "class": "クラス",
      "timeline": "予定表",
      "edit_timeline": "予定表を編集する",
      "confirm": "確認する",
      "cancel": "取り消す",
      "days": "{0}日",
      "before_due": "期限日前"
    },
    "modals_edit_timeline": {
      "title": "予定表の更新に成功しました。",
      "description": "あなたの担当学習者たちは,この変更に関する通知を受け取ります。",
      "button_text": "了解"
    }
  },
  "classes": {
    "accepted_users": "受け取り済みのユーザー",
    "pending_users": "保留中のユーザー",
    "success_class_updated": "クラスの更新に成功しました",
    "success_remove_user": "ユーザーのクラスからの削除に成功しました",
    "reports": "報告",
    "filter_menu": {
      "all": "すべて",
      "active": "アクティブ",
      "not_started": "未開始",
      "draft": "下書き",
      "finished": "完成"
    },
    "table_titles": {
      "start_date": "開始日",
      "end_date": "終了日",
      "status": "ステータス"
    },
    "classes_details": {
      "left": "放置",
      "to_go": "残り",
      "edit_class_name": "{name}を編集する",
      "menu": {
        "overview": "概観",
        "detailed_progress": "詳細な進捗状況",
        "time_tracking": "時間追跡",
        "assignment": "課題",
        "assessment": "評価"
      },
      "overview_section": {
        "title": "概要",
        "students": "学習者",
        "view_list": "リストを見る",
        "goals": "目標",
        "no_goals_set": "このクラスには目標が設定されていません",
        "minutes_per_day": "1日当たりの分数",
        "days_practice_per_week": "1週間当たりの練習日",
        "set_goals": "目標を設定する",
        "assessment_test_results": "評価テストの結果",
        "average_score": "平均点",
        "test_before_class_stats": "評価テスト受験までの日数"
      },
      "students_section": {
        "title": "学習者",
        "pro_licence": "プロ・ライセンス",
        "assessment_test": "評価点",
        "pronunciation": "発音",
        "intonation": "イントネーション",
        "fluency": "流ちょうさ",
        "word_linkage": "単語のつながり",
        "ending_sounds": "終了音",
        "pausing": "休止",
        "pace": "ペース",
        "text": "テキスト",
        "volume": "声量",
        "date_take_assessment": "評価日",
        "last_active_practice": "最終練習時刻",
        "practice_days_week": "週あたりの練習日",
        "min_spent": "所要時間（分）",
        "last_eps": "最終EPS",
        "lesson_count": "#授業",
        "avg_daily_use": "平均の毎日の使用時間（分）",
        "copy_paste_emails": "メールアドレスをコピーして貼り付け",
        "module_name": "モジュール名",
        "lesson_name": "レッスン名",
        "lesson_EPS": "レッスンEPS",
        "lesson_take_date": "デートレッスン",
        "difficulty_level": "難易度レベル",
        "skill_name": "スキル名",
        "skill_score": "スコア"
      },
      "activity_reports": {
        "title": "アクティビティレポート",
        "lessons_overview": "レッスン概要",
        "number_of_lessons_practiced": "練習したレッスンの数と分",
        "average_practice": "平均練習時間（分）",
        "progress": "進捗チャート（平均EPS）",
        "progress_student": "進捗チャート（EPS）",
        "0_5_percent": "0% - 5%",
        "6_10_percent": "6% - 10%",
        "11_50_percent": "11% - 50%",
        "51_70_percent": "51% - 70%",
        "mt_70_percent": " 70%以上"
      },
      "assessment": {
        "table": {
          "date": "最終評価日",
          "eps": "最終評価スコア",
          "ons": "発音",
          "sis": "イントネーション",
          "fls": "流暢さ",
          "overall_score": "総合スコア",
          "word_linkage": "ワードリンケージ",
          "ending_sounds": "終わりの音",
          "pausing": "一時停止",
          "pace": "ペース",
          "text": "テキスト",
          "btn_history": "履歴"
        }
      },
      "edit_class": {
        "available_licenses": "利用可能なライセンス:",
        "table": {
          "email": "メールアドレス",
          "first_name": "下の名前",
          "last_name": "名字",
          "license": "ライセンス",
          "exist_license": "既存のライセンス",
          "title": "ライセンスの割り当て",
          "invite_only": "招待のみ,ライセンスは必要ありません"
        }
      }
    },
    "create_class_flow": {
      "save_finish_later": "保存して後で終了させる",
      "cancel": "キャンセル",
      "save": "保存",
      "next": "続行",
      "previous": "戻る",
      "details": "詳細",
      "list_students_modal": {
        "got_it": "分かりました！",
        "warning_no_student": "学習者は招待されません"
      },
      "class_details": {
        "team_detail_tooltip": "各チームには,名前とELSAパッケージが必要です。",
        "start_end_date": "開始日と終了日",
        "start_day": "開始日",
        "pick_a_day": "日を選ぶ",
        "end_date": "終了日",
        "invalid_email_msg": "無効なメールアドレス"
      },
      "add_students": {
        "copy_paste_emails": "メールアドレスをコピーして貼り付ける",
        "insert_multiple_emails": "複数のメールアドレスを入力してください（コンマで区切ってください）"
      },
      "class_overview": {
        "details": "詳細",
        "start_end_date": "開始日と終了日",
        "not_selected": "選択されていません",
        "create_and_send_invites": "招待を作成して送信"
      },
      "class_created": {
        "goals_section": {
          "practice_at_least": "少なくとも練習",
          "days_week": "週に数日。",
          "keep_them_engaged": "週1回の頻度で彼らに関わってもらうようにする",
          "practice": "練習",
          "minutes_day": "1日数分。",
          "studies_review": "研究により,新しい言語を学ぶ時は少なくとも1日10分練習すると,最良の結果が得られることが示されています。",
          "take_assessment_test": "評価テストを受ける",
          "days_before_invitations": "招待から数日後。",
          "next": "次",
          "will_do_this_later": "後でやります。",
          "assessment_test_desc": "チームが評価を完了する必要がある日付を設定します。",
          "first_assessment_test": "次の前に完了:",
          "second_assessment_test": "次の前に最後の評価:",
          "pick_a_day": "日を選ぶ",
          "send_reminders": "リマインダーを送信:",
          "learners": "学習者",
          "table": {
            "email": "メールアドレス",
            "first_name": "下の名前",
            "last_name": "名字",
            "license": "ライセンス",
            "invite_only": "招待のみ,ライセンスは必要ありません"
          }
        },
        "engage_with_your_students": "生徒と交流する",
        "class_created_and_invited": "クラスが作成され,100人の生徒が招待されました！",
        "congratulation": "おめでとうございます！"
      },
      "available_licenses": "利用可能なライセンス:",
      "assign_licenses_to_learners": "クリックして学習者にライセンスを割り当てる",
      "assign_all": "すべて割り当て",
      "clear_all": "すべてクリア",
      "table": {
        "email": "メールアドレス",
        "first_name": "名",
        "last_name": "姓",
        "license": "ライセンス",
        "title": "ライセンスを割り当て",
        "invite_only": "招待のみ,ライセンスは必要ありません"
      }
    },
    "status": {
      "active": "アクティブ",
      "finished": "完了",
      "not_started": "開始していません",
      "pending": "保留中",
      "draft": "下書き"
    }
  },
  "dashboard": {
    "reports_overview": "レポートの概要",
    "notifications": "通知",
    "overview": "概要情報",
    "manage": "管理",
    "licenses": "ライセンス",
    "users": "ユーザー",
    "request_license": "ライセンスのリクエスト",
    "student": {
      "view_class": "クラスを見る",
      "view_all_classes": "すべてのクラスを見る",
      "goals": {
        "minutes_per_day": "1日あたり {minutes} 分の目標",
        "minutes_per_day_value": "あなたの平均は1日あたり { minutes } 分です",
        "days_per_week": "1週間あたり {days} 日の目標",
        "days_per_week_value": "あなたの練習の平均は1週間あたり {days} 日です",
        "level": "レベル {level}",
        "level_value": "{level}% の平均"
      },
      "minutes_spend_per_day": "分は,1日あたりに費やされた平均時間です"
    },
    "your_class": "あなたのクラス"
  },
  "charts": {
    "score": "スコア",
    "active_users": "アクティブユーザー",
    "avg_practice_time": "平均練習時間",
    "avg_practicetime_perday": "1日あたりの平均練習時間",
    "avg_eps": "EPS",
    "avg_eps_full": "平均 EPS",
    "number_of_lessons": "レッスンの数",
    "number_of_seconds": "費やした時間",
    "lessones_practices": "練習したレッスン",
    "more_than_the_set_goal": "設定された目標以上",
    "less_than_the_set_goal": "設定された目標以下",
    "from_last_period": "前期から",
    "hours_practiced": "練習した時間",
    "hours_practiced_tooltip": "値は時間に四捨五入されます。",
    "level_value": " {level}% の平均",
    "minutes_spent": "費やした分",
    "minutes_practiced": "練習した分",
    "minutes_goal": "分の目標",
    "hour_goal": "時間の目標",
    "hours_spent": "費やした時間",
    "lessons_practiced": "練習したレッスン",
    "user_eps_score": "EPS",
    "not_active": "非アクティブ",
    "1_4_days": "週1〜4日",
    "5_5_days": "週5日",
    "6_7_days": "週6〜7日",
    "percentage": "パーセンテージ",
    "average_elsa_score": "平均ELSAスコア",
    "average_elsa_score_desc": "組織内の学習者の結果に基づいています",
    "average_elsa_score_title": "組織の平均レベル",
    "pentagon_title": "スキル別のELSAスコアの内訳",
    "pentagon_desc": "個人の結果に基づく",
    "ielts_title": "IELTSスピーキングスコア予測",
    "ielts_desc": "このスコアは,IELTSまたはIDPによって承認されていません",
    "no_ielts_data_title": "学習者からのデータはまだ十分ではありません。",
    "no_ielts_data_desc": "学習者に,評価テストを受けるか,より多くのレッスンを練習してスピーキングスコア予測を取得するように促します。",
    "distribution_by_learners_title": "学習者の分布",
    "distribution_by_learners_desc": "ELSAのスコア範囲に基づいて計算されます。",
    "ielts_score": {
      "no_data": "データ無し",
      "very_poor": "非常に不十分",
      "intermittent": "間欠的",
      "extremely_limited": "非常に限定的",
      "limited": "限定的",
      "modest": "中級",
      "competent": "有能",
      "good": "素晴らしい",
      "very_good": "大変良い",
      "expert": "エキスパート"
    },
    "elsa_score_range": {
      "native": "ネイティブ",
      "advanced": "上級",
      "intermediate": "中級",
      "lower_intermediate": "初中級",
      "beginner": "入門者"
    },
    "distribution_eps": {
      "learn_more": {
        "native": "ネイティブ:90％以上",
        "advanced": "上級:78％～89％",
        "intermediate": "中級:67％～77％",
        "lower_intermediate": "下中級:56％～66％",
        "beginner": "入門者:56％未満"
      }
    },
    "average_elsa_score_historical_progress": {
      "titleY": "平均EPS（％）"
    },
    "lowest_average_score_skills_title": "改善分野",
    "highest_average_score_skills_desc": "トップの最も強いスキル",
    "lowest_average_score_skills_desc": "トップのミス",
    "leaderboard": "リーダーボード",
    "learner_col_label": "学習者の名前",
    "score_col_label": "ELSAスコア",
    "duration_col_label": "練習時間",
    "lessons_total_col_label": "練習したレッスン",
    "highest_average_score_skills_title": "個人の成果",
    "individualview_leaderboard_org_label": "個人の表示",
    "tooltips": {
      "individual_eps": "選択した期間の最新のEPSスコア",
      "individual_durations": "「時:分:秒」の形式で選択した期間に学習者が練習した合計時間",
      "individual_lessons_total": "学習者が練習したレッスンの総数"
    },
    "mix": {
      "number_of_lessons": "レッスンの数",
      "number_of_minutes": "分の数"
    },
    "total_learners": "合計学習者",
    "no_data": "データ無し",
    "learn_more": "もっと詳しく",
    "learner": "学習者",
    "skill_name": "スキル - {0}",
    "pronunciation": "発音",
    "fluency": "流暢さ",
    "word_stress": "語強勢",
    "listening": "リスニング",
    "branchview_leaderboard_org_label": "",
    "branch_col_label": ""
  },
  "information": {
    "active_students": "学習者がELSA Speakアプリを使用し,少なくとも1つのレッスンを終了した場合,その学習者はその日のアクティブな学習者と見なされます",
    "active_students_chart": "このグラフでは,レポートを生成するために選択したトグルに基づいて,日,週,または月ごとにアクティブな学習者の内訳を確認することができます。",
    "activity_reports_progress": "英語能力スコア（EPS）:英語を話すユーザーの能力を表すグローバルスコア",
    "students_improvement": "このグラフは,EPSの改善に基づくレポート期間内にクラス/チームがどのように改善したかについてのレポートを提供します",
    "export_report_button": "期間内の要約アクティビティレポートをエクスポート",
    "export_assessment_button": "期間内のすべての詳細評価テストをエクスポート",
    "export_lesson_detail_button": "期間内のすべてのレッスン詳細レポートをエクスポート",
    "assessment_test_col": "評価を受ける時点で,英語を話すユーザーの現在のEPSを表します",
    "study_set_input_items": "アイテムは140文字（スペースを含む）を超えてはならないことに注意してください。",
    "reminder_tooltip": "リマインダーは,携帯電話のプッシュ通知として学習者に送信されます。学習者に思い出してほしい時間を指定してください。",
    "show_from_to_of_total": "{total} の {start} から {end} を表示"
  },
  "contract": {
    "contract_start": "契約開始",
    "contract_start_desc": "これはあなたの契約が始まる日付です",
    "contract_renewal": "契約終了",
    "contract_renewal_desc": "これはあなたの契約が終了する日です",
    "learners": "学習者",
    "no_contract": "契約はありません。",
    "order_number": "注文番号:"
  },
  "homework": {
    "set_reminder": "リマインダーを設定",
    "create_new_assignment": "新しい課題を作成",
    "assignment_information": "課題の情報",
    "lesson_sets": "レッスンセット",
    "study_sets": "スタディセット",
    "remove": "削除",
    "errors": {
      "please_provide_name": "名前を入力してください",
      "please_provide_start_on": "開始日を入力してください",
      "please_provide_due_on": "期日を記入してください",
      "please_provide_start_time": "開始時間を入力してください",
      "please_provide_due_time": "期限を入力してください"
    },
    "modals": {
      "delete": "レッスンを完全なセットにするために,このアイテムを保持することをお勧めします。それでも続行しますか？",
      "delete_all": "これらのアイテムを削除すると,課題の品質に影響を与える可能性があります。それでも続行しますか？",
      "create_success": "課題が正常に作成されました！",
      "assign_to_class": {
        "assign_to_class": "クラスに割り当て",
        "selected_assignment": "選択された課題",
        "select_a_class_to_assign_to": "割り当てるクラスを選択",
        "assign_success": "課題が正常に割り当てられました！"
      }
    },
    "tooltip": {
      "due_date": "これは,学習者が課題を完了する必要がある日付です。",
      "start_date": "これは,課題が学習者に利用可能になる日付です。",
      "set_reminder": "指定された日時に,課題をまだ完了していない学習者は,プッシュ通知リマインダーを受け取ります。"
    },
    "form": {
      "due_date": "期日",
      "start_date": "開始日",
      "assignment_name": "課題名",
      "assign_to": "割り当て",
      "start_time": "開始時間",
      "due_time": "期限",
      "before_the_due_date": "期日の前",
      "due_date_validate_msg": "0日",
      "0_day": "0日"
    },
    "buttons": {
      "select_lesson": "レッスンを選択",
      "review": "レビュー",
      "create_assignment": "作成して割り当て",
      "cancel": "キャンセル",
      "back": "戻る"
    },
    "create_assignment": {
      "skill": "スキル",
      "23_skills": "23スキル",
      "topics": "トピック",
      "15_categories": "15カテゴリー",
      "game_types": "ゲームタイプ",
      "6_game_types": "6ゲームタイプ",
      "filter_by_level": "レベルでフィルタリング",
      "easy": "やさしい",
      "medium": "ふつう",
      "difficult": "むずかしい",
      "very_difficult": "とてもむずかしい"
    },
    "lesson_set_levels": "{0}レベル",
    "lesson_set_remove_all": "すべて削除",
    "lesson_set_skill": "スキル {0} - ",
    "lesson_set_level": "レベル {0} - ",
    "study_sets_title_skill": "スキル {0} - ",
    "study_sets_title_level": "レベル {0} - ",
    "assignment_review": {
      "levels": "{0}レベル",
      "remove_all": "すべて削除",
      "skill": "スキル {0} - ",
      "level": "レベル {0} - "
    },
    "head_section": {
      "input information": "情報を入力",
      "select_lessons": "— レッスンを選択",
      "review_assignment": "— 課題を確認"
    },
    "assignment_skill": {
      "levels": "{0}レベル",
      "levels_label": "レベル",
      "level_label": "レベル",
      "add_all_to_assignment": "すべてを課題に追加する",
      "remove_all_from_assignment": "すべてを課題から削除する",
      "skill_title": "スキル {0} - ",
      "level_title": "レベル {0} - "
    },
    "assignment_lib": {
      "table_selected_label": "{1}件中{0}件を選択しました",
      "reset": "リセット",
      "confirm": "確認する",
      "listening": "リスニング",
      "pronunciation": "発音",
      "word_stress": "語強勢",
      "conversation": "会話",
      "intonation": "イントネーション",
      "study_sets": "学習セット",
      "video_conversation": "ビデオ会話",
      "missing_character":"Missing Character",
      "unscramble_word": "Unscramble Word",
      "click_to_sort": "クリックしてソート",
      "reverse_sort_direction": "ソート順を逆転"
    }
  },
  "homework_library": {
    "create_assignment": "課題の作成",
    "search_assignment": "課題を検索する",
    "table": {
      "assignment_name": "課題名",
      "lesson_type": "レッスンタイプ",
      "created_on": "作成日",
      "recent_assigned_class": "最近割り当てられたクラス",
      "remove": "削除する",
      "assigned_to": "以下へ割り当てられました:",
      "due_date": "期日",
      "start_date": "開始日",
      "duplicate": "コピーの作成"
    },
    "created_on": "作成日:",
    "assigned_to": "割り当て先:",
    "class_assigned": "割り当てられたクラス",
    "remove_title": "課題を削除しようとしています！",
    "remove_desc": "選択した課題は,課題ライブラリからのみ削除されます。これにより,学習者の作業とその進捗に影響は及びません。",
    "remove_success": "課題が正常に削除されました",
    "remove_warning": "課題を削除できませんでした",
    "duplicate_title": "コピーを作成して編集",
    "duplicate_success": "{name}の新しいコピーが正常に作成されました",
    "create_success": "課題が正常に作成されました！",
    "curriculum": "カリキュラム"
  },
  "plan_payment": {
    "tooltip_activated_warning": "これらライセンスは自動で有効化されています。{date}に期限が切れるまで,それらを割り当てて利用することができます",
    "tooltip_invalid_warning": "これらのライセンスは使用できなくなりました。",
    "tooltip_auto_active_warning": "ライセンスを有効期間の初めから終わりまで利用するには,1週間以内に引き換えを行う必要があります。",
    "org_name_plan_title": "グループ・{0}・プランと支払い",
    "title": "プランと支払い",
    "desc": "プランの表示,支払い方法の管理,さらなるパッケージの購入を行います。",
    "lite_annual": "ライト（年単位）",
    "lite_semi_annual": "ライト（半年単位）",
    "lite_quarterly": "ライト（四半期単位）",
    "medium_annual": "ミディアム（年単位）",
    "medium_semi_annual": "ミディアム（半年単位）",
    "medium_quarterly": "ミディアム（四半期単位）",
    "payment_method": {
      "title": "支払い方法",
      "add_a_new_card": "新しいカードを追加する",
      "card_details": "カードの詳細",
      "success_msg": "決済が正常に処理されました。Eメールで領収書をご確認ください。",
      "failed_msg": "決済できませんでした！カードの詳細を確認して,もう一度お試しください。"
    },
    "payment_summary": {
      "title": "購入概要",
      "sub_title": "あなたのサブスクリプション:",
      "user_month": "/ユーザー/月",
      "number_of_users": "ユーザー数",
      "total": "トータル",
      "you_save": "{0}の節約になります",
      "next_billing_date": "次回の請求日:",
      "can_cancel": "次回の請求日までにサブスクリプションをキャンセルすれば,以後の請求を回避することができます。",
      "subscribe": "定期購入する",
      "footer_term_1": "100ユーザー超の分を購入する場合は,",
      "footer_term_2": "セールスまでご連絡ください",
      "footer_term_3": "カスタム価格をご案内します。"
    },
    "payment_plan": {
      "title": "新しいプランを定期購入する",
      "select_a_plan": "プランを選択する",
      "number_of_users": "ユーザー数",
      "your_benefits": "あなたのメリット:",
      "benefits": {
        "benefit_1": "ELSAプロへのアクセス",
        "benefit_2": "3,000を超すレッスンとエクササイズ",
        "benefit_3": "レポートと分析",
        "benefit_4": "カスタム課題とレッスン",
        "benefit_5": "従業員向け英語テストサービス",
        "benefit_6": "バーチャル導入セッション"
      }
    }
  },
  "contact": {
    "order_number": "注文番号:"
  },
  "english_testing_service_for_employees": "従業員向け英語テストサービス",
  "class_assessment_exporter": {
    "student_name": "生徒名"
  },
  "chart": {
    "intonation": "イントネーション"
  },
  "teachers": {
    "title": "教師"
  },
  "style_guide": {
    "button_title": "ボタン {0}",
    "elsa_button": "ELSAボタン",
    "elsa_primary_button": "ELSA一次ボタン",
    "elsa_green_button": "ELSAグリーンボタン",
    "elsa_secundary_button": "ELSA二次ボタン",
    "elsa_tertiary_button": "ELSA三次ボタン",
    "checkbox_checklist": "チェックボックス {0}",
    "option_a": "オプションA",
    "radio_radio": "ラジオ {0}",
    "option_b": "オプションB",
    "option_c": "オプションC",
    "option_d": "オプションD",
    "input_email_password": "入力 {0}:{1}",
    "email": "Eメール",
    "password": "パスワード",
    "autocomplete_selected": "自動コンプリート {0}",
    "elsa_input": {
      "password": {
        "placeholder": "パスワードを挿入してください"
      },
      "email": {
        "placeholder": "user@example.com",
        "label": "Eメール"
      },
      "autocomplete": {
        "placeholder": "『a』を入力"
      }
    },
    "chip": {
      "title": "チップ {0}",
      "verify": "確認する"
    },
    "forgot_password": {
      "title": "パスワード忘れ:{0}"
    }
  },
  "menu": {
    "get_set_up": "セットアップする",
    "dashboard": "ダッシュボード",
    "curriculum": "カリキュラム",
    "learners": "学習者",
    "plan_payment": "プランと支払い",
    "account": "アカウント",
    "organizations": "組織"
  },
  "organizations_team": {
    "invite": "招待する",
    "accepted_learners": "受け入れた学習者",
    "total_learners": "学習者総数",
    "start_date": "開始日",
    "end_date": "終了日",
    "status": "ステータス",
    "invited_leader_to_team": "チームに招待されたリーダー",
    "could_not_invited_leader_to_team": "チームにリーダーを招待できませんでした"
  },
  "account": {
    "account_detail": "アカウント詳細"
  },
  "student_detail": {
    "no_classes_available": "利用できるクラスはありません",
    "last_eps": "直近のEPS",
    "assessment_test": "アセスメントテスト"
  },
  "admin_organization_switcher": {
    "title": "",
    "organization": ""
  }
}
